import { $, cabtv_wp_request, Cookies } from "./core.js";
import * as dom from "livestreamer/utils/dom";
import * as ui from "livestreamer/utils/dom/ui";
import * as utils from "livestreamer/utils";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import NoSleep from '@uriopass/nosleep.js';
// import MobileDetect from 'mobile-detect';
import ResizeObserver from 'resize-observer-polyfill';


// confetti
// <script src="https://cdn.jsdelivr.net/npm/@tsparticles/confetti@4.2.0/tsparticles.confetti.bundle.min.js"></script>
          

// import {Tooltip} from "bootstrap";

/** @type {import("./front.js").CABTVFrontApp} */
const cabtv = window.cabtv;

import "./live.scss";

// var mobile_detect = new MobileDetect(window.navigator.userAgent);
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const SHOW_CHAT_HEADER = false;

const urls_regex = /(https?:\/\/[^\s]+)/gi;
let fake_chat_id = 0;

const DEBUG = window.location.search.includes("debug");

ui.Tooltip.defaults.appendTo = document.body;

const CHAT_CLIENT_EXPIRE_TIME = 1000 * 60 * 2;
const CHAT_GAP = 1000 * 60 * 60 * 6;
const CHAT_BLOCK_AMOUNT = 50;
const BLACK_IMG_SRC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";
const IS_CHAT_MODE = new URL(location.href).searchParams.has("chat");
const major_version = 1.1;
const MAX_COMMENT_LENGTH = 200;
const MIN_SCROLL_PAUSE_THRESHOLD = 20;
// const WAIT_UNTIL_FIRST_FOCUS = 0;
const DAYS_LOOKUP = {
    "monday": 1,
    "tuesday": 2,
    "wednesday": 3,
    "thursday": 4,
    "friday": 5,
    "saturday": 6,
    "sunday": 7
}

var fireworks;
async function show_fireworks(container_el, {rand}) {
    if (!fireworks) {
        // const FireWorksModule = is_halloween() ? await import("./halloween-fireworks.js") : await import("./fireworks.js");
        const FireWorksModule = await import("./fireworks.js");
        fireworks = new FireWorksModule.default();
    }
    if (fireworks.elem.parentElement !== container_el) {
        fireworks.elem.style.position = "absolute";
        fireworks.elem.style.inset = "0";
        container_el.append(fireworks.elem);
    }
    fireworks.volume = app.settings.get("audio-volume");
    await fireworks.createSequence(rand, is_halloween() ? "Halloween" : null);
    await utils.timeout(2000);
    await $(container_el).fadeOut(1000).promise();
    container_el.remove();
    return;
}

let shark_gift;
async function show_shark(container_el, {rand}) {
    if (!shark_gift) {
        const SharkModule = await import("./shark.js");
        shark_gift = new SharkModule.default({
            templateUrl: cabtv.template_url,
        });
    }
    await shark_gift.play(container_el, { rand });
    app.play_sound(cabtv.template_url + "/audio/jaws.mp3", 0.3);
}

function show_goal(container_el) {
    let src = `${cabtv.template_url}/video/goal.webm`;
    /** @type {HTMLVideoElement} */
    var video = $(`<video>`)[0];
    video.src = src;
    container_el.append(video);
    video.style.opacity = 0;
    if (!document.hasFocus()) video.muted = true;

    var corner = true;
    if (corner) {
        video.width = 340;
        video.style.position = "absolute";
        video.style.right = 0;
        video.style.bottom = 0;
    } else {
        video.style.position = "absolute";
        video.style.left = "50%";
        video.style.top = "50%";
        video.style.transform = "translate(-50%, -50%)";
    }

    video.volume = 0.25 * app.settings.get("audio-volume");
    video.onended = ()=>{
        container_el.remove();
    }
    var play = ()=>{
        video.style.opacity = 1;
        video.play();
    }
    if (video.readyState >= 3) {
        play();
    } else {
        video.oncanplay = ()=>{
            play();
        }
    }
    return;
}
// Small 53-bit-seedable PRNG so gifts render identically on every client.
// `rand` is up to Number.MAX_SAFE_INTEGER, so fold it into 32 bits first.
function make_rng(seed) {
    let s = ((seed % 0x100000000) ^ (Math.floor(seed / 0x100000000) % 0x100000000)) >>> 0;
    if (s === 0) s = 0x9E3779B9;
    return function() {
        s = (s + 0x6D2B79F5) >>> 0;
        let t = s;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

async function show_simple_gift(container_el, {gift, rand}) {
    add_keyframes(`wobble`, `0% { transform: rotate(-10deg); } 50% { transform: rotate(10deg); } 100% { transform: rotate(-10deg); }`)
    add_keyframes(`float-upwards`, `0% { opacity: 0; top: 100%; transform: scale(0.8); } 10% { opacity: 1; transform: scale(1); } 80% { opacity: 1; } 100% { top: calc(100% - 220px); opacity: 0; }`);

    // --- Violent shake + horizontal flip for the Psycho gift ---
    add_keyframes(`vibrate`, `
        0%   { transform: translate(0, 0)      rotate(0deg);  }
        10%  { transform: translate(-3px, 2px) rotate(-4deg); }
        20%  { transform: translate(3px, -2px) rotate(4deg);  }
        30%  { transform: translate(-3px, -3px) rotate(-3deg); }
        40%  { transform: translate(3px, 3px)  rotate(3deg);  }
        50%  { transform: translate(-2px, 3px) rotate(-4deg); }
        60%  { transform: translate(2px, -3px) rotate(4deg);  }
        70%  { transform: translate(-3px, 2px) rotate(-3deg); }
        80%  { transform: translate(3px, -2px) rotate(3deg);  }
        90%  { transform: translate(-2px, -2px) rotate(-2deg); }
        100% { transform: translate(0, 0)      rotate(0deg);  }
    `);
    add_keyframes(`flip`, `
        0% { transform: rotateY(0deg); }
        49.99% { transform: rotateY(0deg); }
        50% { transform: rotateY(180deg); }
        100% { transform: rotateY(180deg); }
    `);

    // One PRNG per gift send — deterministic across clients, varied per image.
    const rng = make_rng(rand);
    const rand_int = (min, max) => min + Math.floor(rng() * (max - min + 1));
    const random_between = (min, max, t = rng()) => min + t * (max - min);

    const NUM_GIFTS = 6;
    const SPREAD = Math.min(300, Math.max(150, (container_el.offsetWidth || 300) * 0.6));
    const SLOT_W = SPREAD / NUM_GIFTS;

    const slots = [...Array(NUM_GIFTS).keys()];
    for (let s = slots.length - 1; s > 0; s--) {
        const j = Math.floor(rng() * (s + 1));
        [slots[s], slots[j]] = [slots[j], slots[s]];
    }

    if (gift === "ghosts") {
        app.play_sound(cabtv.template_url + "/audio/ghosts.mp3", 0.4);
    } else if (gift === "balloons") {
        app.play_sound("gift", 0.3);
    } else if (gift === "psycho") {
        app.play_sound(cabtv.template_url + "/audio/psycho.mp3", 0.3);
    }

    for (var i = 0; i < NUM_GIFTS; i++) {
        await new Promise(resolve => setTimeout(resolve, 250));

        let w = rand_int(100, 150);
        let src = `images/balloon${rand_int(1, 3)}.png`;

        if (gift === "ghosts") {
            src = `images/ghost.png`;
            w *= 0.5;
        } else if (gift === "psycho") {
            src = `images/psycho.png`;
            w *= 0.5;
        }
        src = `${cabtv.template_url}/${src}`

        let el = $(`<div class="balloon"><div><img src="${src}"></div></div>`)[0];
        let inner_el = el.querySelector("div");
        let img_el = inner_el.querySelector("img");
        img_el.style.width = "100%";

        if (gift === "psycho") {
            const image_seed  = rng();
            const vibrate_dur = random_between(0.08, 0.20, image_seed).toFixed(3);
            const flip_dur    = random_between(0.5,  1.5,  image_seed).toFixed(3);
            inner_el.style.willChange = "transform";
            inner_el.style.animation = `vibrate ${vibrate_dur}s linear infinite`;
            img_el.style.willChange = "transform";
            img_el.style.backfaceVisibility = "visible";
            img_el.style.animation = `flip ${flip_dur}s linear infinite`;
        } else {
            inner_el.style.animation = `wobble 1s infinite`;
            img_el.style.transform = `scale(1) ${rng() < 0.5 ? "rotateY(180deg)" : ""}`;
        }

        // Take a slot off the shuffled list — position decoupled from `i`.
        const slot_index  = slots[i];
        const slot_center = slot_index * SLOT_W + SLOT_W / 2;
        const jitter      = (rng() - 0.5) * SLOT_W * 0.6;
        let x = slot_center + jitter - w / 2;

        // Tiny random launch delay (0–150ms) so they don't move in perfect
        // lockstep, but they still clearly release *together* — not in a line.
        el.style.position = "absolute";
        el.style.animation =
            `float-upwards cubic-bezier(.21,.21,.65,.68) 1.5s 0s normal both`;
        el.style.width = `${w}px`;
        el.style.right = `${x}px`;
        el.style.top = "100%";
        container_el.append(el);
    }
    setTimeout(() => container_el.remove(), 2000);
}

const gifts = [
    {
        type: "balloons",
        icon: svg_icon("balloons",1.5),
        label: `Balloons`,
        show: show_simple_gift
    }, 
    {
        type: "fireworks",
        icon: svg_icon("fireworks",1.5),
        label: `Fireworks`,
        show: show_fireworks
    },
    {
        type: "goal",
        icon: svg_icon("football",1.5),
        label: `Goal`,
        special: true,
        visible: ()=>app.$._client.user.is_admin,
        show: show_goal
    },
    {
        type: "ghosts",
        icon: svg_icon("ghosts",1.5),
        label: `Ghosts`,
        visible: ()=>app.$._client.user.is_admin || is_halloween(),
        show: show_simple_gift
    },
    {
        type: "psycho",
        icon: svg_icon("knife", 1.5),
        label: `Psycho`,
        visible: ()=>app.$._client.user.is_admin || is_halloween(),
        show: show_simple_gift
    },
    {
        type: "shark",
        icon: svg_icon("jaws", 1.5),
        label: `Shark`,
        visible: ()=>app.$._client.user.is_admin || is_halloween(),
        show: show_shark
    },
    // {
    //     type: "bats",
    //     icon: svg_icon("bats",1.5),
    //     label: `Bats`,
    //     visible: ()=>app.$._client.user.is_admin || is_halloween(),
    //     show: show_simple_gift
    // }
];

function is_halloween() {
    return is_date_between(null, 10, 24, null, 11, 1);
}

function is_christmas() {
    return is_date_between(null, 12, 15, null, 12, 31);
}

function is_date_between(y0, m0, d0, y1, m1, d1) {

    var now = new Date();

    if (y0 == null && y1 == null) {
        var current = (now.getMonth() + 1) * 100 + now.getDate();
        var start = m0 * 100 + d0;
        var end = m1 * 100 + d1;

        return start <= end
            ? current >= start && current <= end
            : current >= start || current <= end;
    }

    var start = new Date(
        y0 == null ? now.getFullYear() : y0,
        m0 - 1,
        d0
    );

    var end = new Date(
        y1 == null ? now.getFullYear() : y1,
        m1 - 1,
        d1,
        23, 59, 59, 999
    );

    return now >= start && now <= end;
}


/* var comment_status = {
    "-2": "Sent",
    "-1": "Sent",
    "0": "Pending relay",
    "1": "Failed to relay",
    "2": "Invalid comment was not relayed",
    "3": "Relayed successfully",
}; */
var connection_status = {
    "0": "Disconnected",
    "1": "Connecting...",
    "2": "Connected",
};

const CABTV_CO_UK = "cabtv.co.uk"
var host_priority = [
    CABTV_CO_UK,
    // "vk.com",
    // "ok.ru",
    // "live.fc2.com",
];
var host_priority_lookup = {};
host_priority.forEach((h, i) => host_priority_lookup[h] = i);

const NONE = "none";
const AUTO = "auto";

const ASPECT_RATIO_VALUES = [
    // {value: "auto", html:`<span style="padding:0 3px">AUTO</span>`, label:"Automatic Detection"},
    { value: 0, html: "-", label: "None" },
    { value: 4 / 3, html: "4:3", label: "4:3" },
    { value: 16 / 9, html: "16:9", label: "16:9" },
    { value: "cover", html: `<i class="fas fa-arrows-up-down"></i>`, label: "Cover" },
];
var FONT_STYLES = ["", "Helvetica", "Arial", "Times New Roman", "Courier", "Verdana", "Tahoma"];
var FONT_SIZES = [10, 11, 12, 14, 16, 18, 20, 22, 24];

function svg_icon(id, scale = 1.0) {
    var el = $(`<svg class="icon"><use href="#${id}"></use></svg>`)[0];
    if (scale != 1.0) el.style.transform = `scale(${scale})`;
    return el;
}
/** @param {Date|Number} date */
function format_date_human(d) {
    var date = new Date(d);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();
    const ordinal = (n) => {
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    return `${day}${ordinal(day)} ${month} ${year}`;
}


/** @param {HTMLTextAreaElement|HTMLInputElement} element @param {string} text */
function insert_sanitized_text(element, text) {
    const startPos = element.selectionStart;
    const endPos = element.selectionEnd;
    try {
        // Modern browsers (Chrome, Edge, Safari)
        if (document.execCommand) {
            document.execCommand('insertText', false, text);
        } else {
            element.value = value.substring(0, startPos) + text + value.substring(endPos);
        }
        // Restore cursor position
        const newPos = startPos + text.length;
        element.setSelectionRange(newPos, newPos);
    } catch (err) {
        console.error('Failed to insert sanitized text:', err);
    }
}

/** @param {string} text */
function sanitize_comment(text) {
    text = text.replace(/[\n\r]+/g, " ");
    var elems = text.split(" ");
    var length = 0;
    var newelems = [];
    var urls = [];
    for (var i = 0; i < elems.length; i++) {
        var elength;
        if (elems[i].match(urls_regex)) {
            elength = 16;
            urls.push({ url: elems[i], start: length, end: length + elems[i].length });
        } else {
            elength = elems[i].length;
        }
        if (i != elems.length - 1) elength++;
        if ((length + elength) > MAX_COMMENT_LENGTH) {
            elength = MAX_COMMENT_LENGTH - length;
            newelems.push(elems[i].slice(0, elength));
            length += elength;
            break;
        } else {
            newelems.push(elems[i]);
            length += elength;
        }
    }
    text = newelems.join(" ");
    var valid = !!(text && text.length > 0);
    return { text, length, valid, urls };
}

const get_var = (a) => {
    return (typeof a === "function") ? a() : a;
};

class Remote$ extends utils.remote.Proxy$ {

    livestreams = utils.remote.Collection$(() => new LiveStream$()).__proxy__;
    clients = utils.remote.Collection$(() => new Client$()).__proxy__;
    go_lives = utils.remote.Collection$(() => new GoLive$()).__proxy__;
    users = utils.remote.Collection$(() => new User$()).__proxy__;
    chats = utils.remote.Collection$(() => new Chat$()).__proxy__;
    chat_blocklist = {};
    client_id = "";
    location_history = {};
    client_history = {};
    go_lives_hash;
    conf = {
        chat_cooldown: { text: 0, gift: 0, special:0 },
        max_comment_length: 256,
    };
    ts = 0;

    _livestream_id_updates = 0;
    #user_ts = Date.now();
    get _now() {
        return Date.now() + this.ts - this.#user_ts;
    }
    get _active_go_live() {
        return this._go_lives_ordered[0];
    }
    get _go_lives_ordered() {
        return utils.sort(Object.values(this.go_lives), gl => -gl.post_date);
    }
    get _livestreams_ordered() {
        return utils.sort(
            Object.values(this.livestreams),
            (ls) => ls._go_live ? -ls._go_live.post_date : 0,
            (ls) => ls._go_live ? ls._go_live.livestream_ids.indexOf(ls.id) : Number.MAX_SAFE_INTEGER,
            (ls) => ls.is_live ? 0 : 1,
            (ls) => ls.is_vod ? 0 : 1,
            (ls) => (ls.host in host_priority_lookup) ? host_priority_lookup[ls.host] : Number.MAX_SAFE_INTEGER,
            (ls) => -ls.online_ts,
            (ls) => (ls.title ?? "").toLowerCase()
        );
    }
    get _active_livestreams() {
        return Object.values(this.livestreams).filter(ls => this._client.livestream_ids.includes(ls.id));
    }
    get _active_livestream() {
        return this._active_livestreams[0];
    }
    get _client() {
        return this.clients[this.client_id] || this.clients[utils.remote.Null$];
    }
    get _user() {
        return this.users[this._client.user_hash] || this.users[utils.remote.Null$];
    }
    get _chat() {
        return this.chats[this._client.chat_id] || this.chats[utils.remote.Null$];
    }
}

class LiveStream$Private {
    /** @type {LiveStreamViewUI} */
    view = null;
    /** @type {LiveStreamThumbnailUI} */
    thumbnail = null;
}

class LiveStream$ extends utils.remote.ProxyID$ {
    is_live = false;
    is_expired = false;
    title = "-";
    duration = 0;
    host = "";
    #private = new LiveStream$Private();
    /** @returns {LiveStream$Private} */
    get _private() { return this.#private; }
    /** @returns {LiveStreamViewUI} */
    get _view() {
        if (!this._private.view) this._private.view = new LiveStreamViewUI(this.__proxy__);
        return this._private.view;
    }
    /** @returns {LiveStreamThumbnailUI} */
    get _thumbnail() {
        if (!this._private.thumbnail) this._private.thumbnail = new LiveStreamThumbnailUI(this.__proxy__);
        return this._private.thumbnail;
    }
    get _duration() {
        if (this.is_live) return (app.$._now - this.online_ts);
        if (this.duration) return this.duration;
        // if (this.online_ts && this.offline_ts) return this.offline_ts - this.online_ts;
        return 0;
    }
    get _is_in_view() {
        return app.current_livestreams.includes(this.__proxy__);
    }
    get _is_only_livestream_in_view() {
        return app.current_livestreams.length === 1 && app.current_livestreams[0].id === this.id;
    }
    get _clients() {
        return Object.values(app.$.clients).filter(c => c.livestream_ids.includes(this.id));
    }
    get _num_clients() {
        return Math.max(this._clients.length, (this.user_count || 0));
    }
    get _num_unique_clients() {
        var t = new Set(this._clients.map(c => c.ip_hash)).size;
        if (this.is_live && this.user_count > t) t = this.user_count;
        return t;
    }
    get _status() {
        return this.is_live ? "live" : this.is_vod ? "vod" : "offline";
    }
    get _group() {
        return Object.values(LIVESTREAM_GROUPS).find(g => g.condition(this));
    }
    get _full_title() {
        var title = this.title_override || this.title || "Untitled";
        /* var go_live = this._go_live;
        if (go_live) {
            var go_live_title = go_live ? go_live.title : null;
            var livestreams = go_live._livestreams;
            if (go_live_title && livestreams.length>1) {
                go_live_title = `${go_live_title} (${livestreams.indexOf(this)+1})`;
            }
            title = go_live_title || title;
        } */
        return title;
    }
    get _thumbnail_url() {
        var go_live = this._go_live;
        return (go_live ? go_live.thumbnail_url : null) || this.thumbnail_url || BLACK_IMG_SRC;
    }
    get _go_live() {
        return Object.values(app.$.go_lives).find(gl => gl.livestream_ids.includes(this.id));
    }
    get _cabtv_url() {
        return `${window.location.href.split("#")[0]}#${this.id}`;
    }
}

class Client$ extends utils.remote.ProxyID$ {
    /** @type {string[]} */
    livestream_ids = [];
    user_hash = "";
    ip_hash = "";
    ip = "";
    chat_id = 0;
    user = {
        email: "",
        is_admin: false,
        user_id: -1,
        username: ""
    }
}

class User$ extends utils.remote.ProxyID$ {
    // these are server time stamps
    cooldown = { text: 0, gift: 0, goal: 0 };
    _get_cooldown(type) {
        if (app.$._client.user.is_admin) return 0;
        var cd = this.cooldown[type] || 0;
        return Math.max(0, cd - app.$._now);
    }
}

class Chat$ extends utils.remote.ProxyID$ {
    name = "";
    get _clients() {
        return Object.values(app.$.clients).filter(c => c.chat_id === this.id);
    }
    get _num_clients() {
        return this._clients.length;
    }
    get _num_unique_clients() {
        return new Set(this._clients.map(c => c.ip_hash)).size;
    }
}

class GoLive$ extends utils.remote.ProxyID$ {
    /** @type {string[]} */
    livestream_ids = [];
    show_multiple = false;
    title = "";
    post_date = 0;
    get _livestreams() {
        return this.livestream_ids.map(id => app.$.livestreams[id]).filter(ls => ls);
    }
}

class LiveStreamGroup$ {
    /** @param {string} id @param {string} label @param {function(LiveStream$):boolean} condition */
    constructor(id, label, condition) {
        this.id = id;
        this.label = label;
        this.condition = condition;
    }
}

class UptimeUI extends ui.UI {
    /** @param {LiveStream$} ls */
    constructor(ls) {
        super(`<div class="uptime">
            <i class="fas fa-circle"></i><span class="uptime-value"></span>
        </div>`);
        this.uptime_el = this.elem.querySelector(".uptime-value");
        this.on("update", () => {
            this.elem.title = ls.is_live ? "Elapsed Time (Live)" : "Elapsed Time (Offline)"
            dom.set_text(this.uptime_el, utils.ms_to_timespan_str(ls._duration));
        });
    }
}

class LiveStreamThumbnailUI extends ui.UI {
    /** @param {LiveStream$} livestream */
    constructor(livestream) {
        var elem = $(`<li class="splide__slide channel-wrapper">`)[0];

        super(elem);

        /** @type {LiveStream$} */
        this.__data = livestream;

        elem.append($(
            `<div class="channel">
                <a href="#${this.__data.id}">
                    <span class="status">OFFLINE</span>
                    <i class="fas fa-play overlay-icon"></i>
                    <div class="image-container"></div>
                </a>
                <div class="overlay"></div>
                <div class="top">
                    <div>
                        <div class="users-wrapper">
                            <i class="fas fa-users"></i>
                            <div class="users"></div>
                        </div>
                        <div class="host"></div>
                    </div>
                    <div>
                        <div class="uptime"></div>
                    </div>
                </div>
                <div class="bottom">
                    <a href="#${this.__data.id}" class="title-wrapper">
                        <span class="title"></span>
                    </a>
                    <button class="dropdown" aria-expanded="false"><i class="fas fa-ellipsis-v"></i></button>
                </div>
            </div>`
        )[0]);

        var dropdown_button = elem.querySelector("button.dropdown");
        var menu = new dom.DropdownMenu({
            trigger: "click",
            target: dropdown_button,
            items: () => {
                let items = [];
                if (this.__data._is_in_view) {
                    // let index = ls_ids.indexOf(ls.id);
                    items.push({
                        label: "Refresh",
                        icon: `<i class="fas fa-redo"></i>`,
                        click: (e) => {
                            this.__data._view.refresh(true);
                        }
                    });
                }
                if (!this.__data._is_only_livestream_in_view) {
                    items.push({
                        label: "Replace View",
                        icon: `<i class="fas fa-desktop"></i>`,
                        click: (e) => {
                            this.__data._view.replace();
                        }
                    });
                }
                if (this.__data._is_in_view) {
                    items.push({
                        label: "Remove from View",
                        icon: `<i class="fas fa-minus"></i>`,
                        click: (e) => {
                            this.__data._view.remove();
                        }
                    });
                } else {
                    items.push({
                        label: "Add to View",
                        icon: `<i class="fas fa-plus"></i>`,
                        click: (e) => {
                            this.__data._view.add();
                        }
                    });
                }
                if (this.__data.url) {
                    items.push({
                        label: `View in New Window`,
                        href: this.__data.url,
                        icon: `<i class="fas fa-external-link-alt"></i>`,
                    });
                    items.push({
                        label: `Copy URL`,
                        click: (e) => {
                            navigator.clipboard.writeText(this.__data._cabtv_url);
                        },
                        icon: `<i class="fas fa-copy"></i>`,
                    });
                }
                if (app.$._client.user.is_admin) {
                    items.push({
                        label: "Debug Info",
                        icon: `<i class="fas fa-bug"></i>`,
                        click: (e) => {
                            new DebugModal(this.__data).show();
                        }
                    });
                    items.push({
                        label: "Delete",
                        icon: `<i class="fas fa-trash"></i>`,
                        click: (e) => {
                            app.delete_livestream(this.__data.id);
                        }
                    });
                }
                return items;
            }
        });

        this.elem.addEventListener("contextmenu", (e) => {
            e.preventDefault();
            menu.toggle(e, { position: "trigger" });
        });

        /* var a = elem.querySelector("a");
        a.onclick = (e)=>{
            e.preventDefault();
            this.__data._view.replace();
        }; */
        
        this.users_elem = elem.querySelector(".users");
        this.channel_elem = elem.querySelector(".channel");
        this.title_elem = elem.querySelector(".title");
        this.host_elem = elem.querySelector(".host");
        this.uptime_elem = elem.querySelector(".uptime");
        this.status_elem = elem.querySelector(".status");
        this.image_container_elem = elem.querySelector(".image-container");

        this.channel_elem.dataset.id = this.__data.id;

        this.on("update", () => {
            dom.set_inner_html(this.users_elem, this.__data._num_clients.toLocaleString());
            dom.set_inner_html(this.title_elem, this.__data._full_title);
            this.channel_elem.title = this.__data._full_title;
            dom.set_attribute(this.channel_elem, "data-status", this.__data._status);
            dom.set_text(this.host_elem, utils.truncate(this.__data.host, 14, "..."));
            if (this.last_thumbnail !== this.__data._thumbnail_url) {
                var new_img = $(`<img loading="lazy"/>`)[0];
                new_img.src = this.last_thumbnail = this.__data._thumbnail_url;
                var last_img = this.image_container_elem.children[0];
                this.image_container_elem.prepend(new_img);
                if (last_img) $(last_img).fadeOut(2000, () => last_img.remove());
            }
            dom.toggle_class(this.channel_elem, "selected", this.__data._is_in_view);
            dom.set_inner_html(this.status_elem, this.__data._status.toUpperCase());
            /* if (!app.is_mobile) {
                this.channel_elem.draggable = true;
                [...this.channel_elem.querySelectorAll("*")].forEach(el=>el.draggable = false);
            } */
            var d = this.__data._duration;
            let str = utils.ms_to_shorthand_str(d || 0, 0, ["d", "s"]) || "-";
            dom.set_text(this.uptime_elem, str);
        });
    }

    focus(instant = false) {
        app.channel_manager.set_group(this.__data._group.id);
    }
}

export class DebugModal extends ui.Modal {
    /** @param {LiveStream$} livestream */
    constructor(livestream) {
        super({
            "modal.title": "Debug Info",
        });
        var text_container = $(`<div class="debug-info" style="white-space:pre-wrap; font-family:monospace;"></div>`)[0];
        this.content.append(text_container);
        text_container.textContent = JSON.stringify(livestream, null, 2);
    }
}

var LiveStreamViewUI_id = 0;
class LiveStreamViewUI extends ui.UI {

    /** @param {LiveStream$} livestream */
    constructor(livestream) {
        var elem = $(
            `<div class="livestream-wrapper">
                <div class="livestream-inner" data-darkmode="true">
                    <div class="video-wrapper"></div>
                </div>
                <div class="livestream-footer">
                    <div class="uptime-wrapper"></div>
                    <h2 class="title"></h2>
                    <div class="buttons"></div>
                </div>
            </div>`
        )[0];

        super(elem);

        this.__id = LiveStreamViewUI_id++;
        this.aspect_ratio = 0;

        this.__data = livestream;

        // <button class="icon header" title="Toggle Header Visibility"><i class="fas fa-heading"></i></button>
        // <button class="icon crop" title="Crop"><i class="fas fa-crop"></i></button>
        this.footer_el = this.elem.querySelector(".livestream-footer");
        this.title_el = this.elem.querySelector(".title");
        this.uptime_wrapper_el = this.elem.querySelector(".uptime-wrapper");

        this.uptime = new UptimeUI(this.__data);
        this.uptime_wrapper_el.append(this.uptime.elem);

        this.buttons_el = this.elem.querySelector(".buttons");

        var buttons = [
            this.backwards_button = new ui.Button(`<button><i class="fas fa-chevron-left"></i></button>`, {
                class: "live-button-icon layout backwards",
                title: "Move Backwards",
                click: () => this.__data._view.move(-1),
                hidden: () => this.__data._is_null || app.current_livestream_ids.length < 2,
                disabled: () => this.__data._view.index <= 0
            }),
            this.forwards_button = new ui.Button(`<button><i class="fas fa-chevron-right"></i></button>`, {
                class: "live-button-icon layout forwards",
                title: "Move Forwards",
                click: () => this.__data._view.move(+1),
                hidden: () => this.__data._is_null || app.current_livestream_ids.length < 2,
                disabled: () => this.__data._view.index >= app.current_livestreams.length - 1
            }),
            this.remove_button = new ui.Button(`<button><i class="fas fa-trash"></i></button>`, {
                class: "live-button-icon layout delete",
                title: "Remove",
                click: () => this.__data._view.remove(),
                disabled: () => this.__data._is_null
            }),
            this.view_external_button = new ui.UI(`<a href="#" target="_blank"><i class="fas fa-external-link-alt"></i></a>`, {
                class: "button live-button-icon external",
                title: "View in New Window",
                update: () => this.view_external_button.elem.href = this.__data.url || "javascript:void()",
                disabled: () => this.__data._is_null
            }),
            this.aspect_ratio_button = new ui.Button(null, {
                class: "live-button-icon live-ratio",
                title: "Toggle Aspect Ratio",
                click: () => this.toggle_aspect_ratio(),
                disabled: () => this.__data._is_null,
                hidden: () => this.has_dynamic_scaling,
            }),
            this.refresh_button = new ui.Button(`<button><i class="fas fa-redo"></i></button>`, {
                class: "live-button-icon refresh",
                title: "Refresh",
                click: () => this.refresh(true),
                disabled: () => this.__data._is_null
            }),
            this.config_button = new ui.Button(`<button><i class="fas fa-cog"></i></button>`, {
                class: "live-button-icon config",
                title: "Configure",
                click: () => this.overlay_container.toggle("video-settings", () => new VideoSettingsInterface(this.__data)),
                disabled: () => this.__data._is_null
            }),
        ];
        new ui.UI(this.buttons_el).append(...buttons);

        this.container_el = this.elem.querySelector(".livestream-inner");
        this.content_el = this.elem.querySelector(".video-wrapper");

        this.overlay_container = new OverlayContainer();
        this.container_el.append(this.overlay_container);

        new ResizeObserver(() => this.update()).observe(this.elem);

        this.on("update", () => {
            this.elem.classList.toggle("mini-mode", this.elem.offsetWidth < 600);
            var ar_data = this.aspect_ratio_data;
            dom.set_inner_html(this.title_el, this.__data._full_title);
            var ar = ar_data.value // || (4/3)
            if (typeof ar === "string" || !ar) ar = (16 / 9);
            // app.elem.style.setProperty("--live-aspect-ratio", ar);

            this.aspect_ratio_button.elem.style.setProperty("--aspect-ratio", ar);
            this.aspect_ratio_button.settings.content = `<div>${ar_data.html}</div>`;

            dom.toggle_class(this.elem, "is-live", !!this.__data.is_live);
            this.elem.dataset.id = this.__data.id;

            var html = this.__data.embed_html;
            if (this.curr_iframe_html !== html) {
                this.curr_iframe_html = html;

                [...this.content_el.children].forEach(c => c.remove());
                /** @type {Element[]} */
                this.content_el.append(...$(html));
                /** @type {HTMLIFrameElement} */
                this.iframe_el = this.content_el.querySelector("iframe");
                if (this.iframe_el) {
                    var src = this.iframe_el.src;
                    var autoplay_mode = app.settings.get("autoplay");
                    var autoplay = (document.hasFocus() && autoplay_mode === "focused") || autoplay_mode === "always";
                    // autoplay = false;
                    try {
                        var url = new URL(src);
                        url.searchParams.set("autoplay", autoplay ? "1" : "0");
                        if (utils.domain_match(this.__data.url, "twitch.tv")) {
                            url.searchParams.set("parent", window.location.host); // necessary for twitch
                        }
                        if (this.__data.host == CABTV_CO_UK) {
                            url.searchParams.set("origin", window.location.origin)
                        }
                        if (DEBUG) url.searchParams.set("debug", "1");
                        this.iframe_el.src = url.toString();
                    } catch { }

                    var allow = new Set([...this.iframe_el.allow.split(/;\s*/).filter(s => s), "screen-wake-lock"]);
                    this.iframe_el.allow = [...allow].join("; ");
                }
            }
            this.update_scale();
        });
    }
    tick() {
        this.uptime.update_next_frame();
    }
    update_scale() {
        var ar_data = this.aspect_ratio_data;
        if (this.has_dynamic_scaling) {
            // app.messenger.request(this.iframe_el.contentWindow, "set_aspect_ratio", ar_data.value).catch((e)=>{});
        } else {
            var video_scale = 1;
            if (ar_data.value) {
                if (ar_data.value === "cover") {
                    let width = this.container_el.offsetHeight * (16 / 9);
                    let height = this.container_el.offsetWidth / (16 / 9);
                    video_scale = Math.max(this.container_el.offsetHeight / height, this.container_el.offsetWidth / width);
                } else {
                    let height = this.container_el.offsetWidth / ar_data.value;
                    let correction_ratio = this.container_el.offsetHeight / height;
                    video_scale = utils.clamp((ar_data.value * correction_ratio), 1, 1.333);
                }
            }
            this.content_el.classList.toggle("has-scaling", video_scale != 1);
            this.content_el.style.setProperty(`--scale`, video_scale);
        }
    };
    
    get has_dynamic_scaling() {
        return this.iframe_el ? this.iframe_el.hasAttribute("data-dynamic-scaling") : true;
    }
    get fixed_aspect_ratio() {
        if (!this.iframe_el) return;
        let url_ob = utils.try_catch(() => new URL(this.iframe_el.src));
        if (url_ob && (url_ob.origin + url_ob.pathname) === "https://www.facebook.com/plugins/video.php") {
            var w = +url_ob.searchParams.get("width");
            var h = +url_ob.searchParams.get("height");
            return w / h;
        }
    }
    get aspect_ratio_data() {
        return ASPECT_RATIO_VALUES[this.aspect_ratio || 0];
    }
    toggle_aspect_ratio() {
        this.aspect_ratio = (this.aspect_ratio + 1) % Object.keys(ASPECT_RATIO_VALUES).length;
        this.update();
    }
    get index() {
        return app.current_livestreams.indexOf(this.__data.__proxy__);
    }
    replace() {
        app.set_livestreams([this.__data.id], true);
    }
    remove() {
        var ids = app.current_livestream_ids.filter(id => id != this.__data.id);
        if (ids.length == 0) ids = [NONE];
        app.set_livestreams(ids, true);
        this.overlay_container.hide();
    }
    add() {
        app.set_livestreams([...app.current_livestream_ids.filter(id => id != this.__data.id), this.__data.id], true);
    }
    move(delta = 1) {
        var ids = [...app.current_livestream_ids];
        var index = this.index;
        ids.splice(index, 1);
        ids.splice(index + delta, 0, this.__data.id);
        ids = ids.filter(id => id);
        app.set_livestreams(ids, true);
    }

    refresh(force_reload = false) {
        if (force_reload) this.curr_iframe_html = null;
        this.update();
        app.viewer.debounced_focus();
    }
}

class InfoLine extends ui.UI {
    constructor(label, content) {
        var elem = $(`<div class="info-line"><div></div><div></div></div>`)[0];
        super(elem);
        this._label_elem = elem.children[0];
        this._inner_elem = elem.children[1];
        this._label = label;
        this._content = content;
        this.on("update", async () => {
            var label = await get_var(this._label);
            dom.set_inner_html(this._label_elem, label);
            var content = await get_var(this._content);
            dom.set_inner_html(this._inner_elem, content);
        })
    }
}

class OverlayContainer extends ui.UI {
    /** @type {Overlay} */
    #overlay;
    #current_id;
    get overlay() { return this.#overlay; }
    constructor() {
        super();
        this.elem.classList.add("overlay-container");
    }
    /** @param {()=>Overlay} cb */
    async toggle(id, cb) {
        var old_id = this.#current_id;
        var hiding = this.hide();
        if (old_id == id) return;
        this.#current_id = id;
        this.#overlay = cb()
        var elem = this.#overlay.elem;
        await hiding;
        await this.#overlay._show();
        this.append(elem);
        $(elem).hide().fadeIn(200);
    }

    async hide() {
        if (!this.#overlay) return;
        var elem = this.#overlay.elem;
        this.#overlay = null;
        this.#current_id = null;
        await $(elem).fadeOut(200).promise();
        elem.remove();
    }
}

class Overlay extends ui.UI {

    constructor(settings) {
        super({
            ...settings
        });

        this.elem.classList.add("overlay");
        this.header_elem = $(`<div class="overlay-header"><span class="title"></span><button class="close-overlay" title="Close"><i class="fas fa-times"></i></button></div>`)[0];
        var content_outer = $(`<div data-overlayscrollbars-initialize>`)[0];
        var os = dom.OverlayScrollbars(content_outer, {});
        this.title_elem = this.header_elem.querySelector(".title");
        this.close_button = this.header_elem.querySelector("button.close-overlay");
        this.close_button.addEventListener("click", () => {
            var oc = ui.closest(this.elem, OverlayContainer);
            oc.hide();
        });
        var viewport = os.elements().viewport;
        this.content = new ui.PropertyGroup();
        this.content.elem.classList.add("overlay-content");
        viewport.append(this.content.elem);

        this.footer_elem = $(`<div class="overlay-footer"></div>`)[0];
        this.elem.append(this.header_elem, content_outer, this.footer_elem);
        this.on("update", () => {
            dom.set_inner_html(this.title_elem, this.get_setting("header"));
        })
    }

    _show() { }
}

class VideoSettingsInterface extends Overlay {
    /** @param {LiveStream$} ls */
    constructor(ls) {
        super({
            header: () => ls._full_title,
        });
        // <i class="fas fa-circle"></i><span id="uptime-value"></span>
        // <button class="live-button-icon backwards" title="Move Backwards"><i class="fas fa-chevron-left"></i></button>
        // <button class="live-button-icon forwards" title="Move Forwards"><i class="fas fa-chevron-right"></i></button>
        // <button class="live-button-icon delete" title="Remove"><i class="fas fa-trash"></i></button>
        // <a href="javascript:void()" target="_blank" class="live-button-icon view-external"><i class="fas fa-external-link-alt"></i></a>
        // <button class="live-button-icon refresh" title="Refresh"><i class="fas fa-redo"></i></button>

        // var uptime_outer = new UI();
        // uptime_outer.append(new ui.Label("Uptime"))
        // var uptime = new UptimeUI(ls);
        // uptime_outer.append(uptime)
        // this.content_elem.append(uptime_outer);

        var controls_outer = new ui.UI();
        var controls = new ui.FlexRow();
        controls.append(
            this.backwards_button = new ui.Button(`<button><i class="fas fa-chevron-left"></i></button>`, {
                title: "Move Backwards",
                click: () => ls._view.move(-1),
                disabled: () => app.current_livestreams.length <= 1 || ls._view.index == 0
            }),
            this.forwards_button = new ui.Button(`<button><i class="fas fa-chevron-right"></i></button>`, {
                title: "Move Forwards",
                click: () => ls._view.move(+1),
                disabled: () => app.current_livestreams.length <= 1 || ls._view.index == app.current_livestreams.length - 1
            }),
            this.remove_button = new ui.Button(`<button><i class="fas fa-trash"></i></button>`, {
                title: "Remove",
                click: () => ls._view.remove(),
                disabled: () => ls._is_null
            }),
        );
        controls_outer.append(new ui.Label(`Layout Controls`), controls);
        this.content.append(controls_outer);

        this.aspect_ratio = new ui.InputProperty(`<select>`, {
            "name": "aspect_ratio",
            "label": "Aspect Ratio",
            "default": 0,
            "options": ASPECT_RATIO_VALUES.map((v, i) => [i, v.label]),
            "info": `Scales the video element to remove letter-boxing and pillar-boxing that occurs when a video's aspect-ratio mismatches the container. Unfortunately this may also obscure elements of the video interface.`,
            "hidden": () => ls._view.has_dynamic_scaling,
            "data": () => ls._view.aspect_ratio,
        });
        this.aspect_ratio.on("change", (e) => {
            if (!e.trigger) return;
            ls._view.aspect_ratio = e.raw_value;
            ls._view.update();
        });
        this.content.append(this.aspect_ratio);

        this.view_external_button = new ui.UI(`<a class="button" href="javascript:void()" target="_blank">View in New Window <i class="fas fa-external-link-alt"></i></a>`, {
            title: "View in New Window",
            update: () => this.view_external_button.elem.href = ls.url,
            disabled: () => ls._is_null
        })
        this.content.append(this.view_external_button);

        this.refresh_button = new ui.Button(`<button>Refresh</button>`, {
            title: "Refresh",
            click: () => ls._view.refresh(true),
            disabled: () => ls._is_null
        })
        this.content.append(this.refresh_button);

        /* this.on("property-change",(e)=>{
            var parts=e.name.split(".");
            ls.view[e.name] =  e.raw_value;
            ls.view.refresh();
        }); */
    }
}

class ChatSettingsInterface extends Overlay {
    constructor() {
        super({
            header: "Settings",
        });
        function get_default() { return app.settings.defaults[this.name]; }
        function get_data() { return app.settings.get(this.name); }

        this.username = new ui.InputProperty(`<input type="text">`, {
            "name": "chat-username",
            "label": "Display Name",
            "default": get_default,
            "data": get_data,
        });
        this.font_sizes = new ui.InputProperty(`<select>`, {
            "name": "chat-font-size",
            "label": "Font Size",
            "default": get_default,
            "data": get_data,
            "options": FONT_SIZES.map(s => ({ value: s, text: String(s) })),
        });
        this.font_styles = new ui.InputProperty(`<select>`, {
            "name": "chat-font-style",
            "label": "Font Style",
            "default": get_default,
            "data": get_data,
            "options": [...FONT_STYLES.map((fs, i) => {
                if (!fs) return { value: fs, text: "BBC Reith Sans (Default)", style: { "font-family": "BBCReithSans" } };
                return { value: fs, text: fs, style: { "font-family": fs } };
            })],
        });
        this.show_gifts = new ui.InputProperty(`<select>`, {
            "name": "show-gifts",
            "label": "Show Gifts",
            "default": get_default,
            "data": get_data,
            "options": [[true, "Yes"], [false, "No"]],
        });
        this.message_audio = new ui.InputProperty(`<select>`, {
            "name": "message-audio",
            "label": "Message Notification",
            "default": get_default,
            "data": get_data,
            "options": [[true, "Yes"], [false, "No"]],
        });
        this.audio_volume = new ui.InputProperty(`<input style="padding:0" type="range" min="0" max="1" step="0.1">`, {
            "name": "audio-volume",
            "label": "SFX Volume",
            "default": get_default,
            "data": get_data,
            "reset": false,
        });
        this.show_comment_timestamps = new ui.InputProperty(`<select>`, {
            "name": "comment-timestamps-mode",
            "label": "Comment Time Stamps",
            "default": get_default,
            "data": get_data,
            "options": [["hh:mm:ss", "Full [hh:mm:ss]"], ["hh:mm", "Short [hh:mm]"], [false, "None"]]
        });
        this.show_avatars = new ui.InputProperty(`<select>`, {
            "name": "show-avatars",
            "label": "Show Avatars",
            "default": get_default,
            "data": get_data,
            "options": [[true, "Yes"], [false, "No"]]
        });
        this.autoplay = new ui.InputProperty(`<select>`, {
            "name": "autoplay",
            "label": "Autoplay Media",
            "default": get_default,
            "data": get_data,
            "options": [["always", "Always"], ["focused", "When Focused"], ["never", "Never"]],
        });
        this.show_blocked_comments = new ui.InputProperty(`<select>`, {
            "name": "show-blocked-comments",
            "label": "Show Blocked Comments",
            "default": get_default,
            "options": [[true, "Yes"], [false, "No"]],
            "hidden": () => !app.$._client.user.is_admin
        });
        this.video_below_chat = new ui.InputProperty(`<select>`, {
            "name": "video-below-chat",
            "label": "Video Below Chat (Mobile)",
            "default": get_default,
            "data": get_data,
            "hidden": () => !app.is_touch,
            "options": [[true, "Yes"], [false, "No"]]
        });
        this.scan_livestreams = new ui.Button("<button>Rescan Live Streams</button>", {
            "click_async": async () => {
                this.scan_livestreams.override_content_temporarily(`Scanning... <i class="fas fa-spinner fa-pulse"></i>`);
                await app.request("scan_livestreams").catch(utils.noop);
                this.scan_livestreams.override_content_temporarily("Done!", 1000);
                await utils.timeout(1000);
            },
            "disabled": () => !app.ws.is_open
            // "hidden":()=>!app.$.client.is_admin
        });
        var refresh_chat_label = "Refresh Chat";
        this.refresh_chat = new ui.Button(`<button>${refresh_chat_label}</button>`, {
            "content": refresh_chat_label,
            "click_async": async () => {
                this.refresh_chat.override_content_temporarily(`Refreshing... <i class="fas fa-spinner fa-pulse"></i>`);
                await app.chat.refresh();
                this.refresh_chat.override_content_temporarily("Done!", 1000);
                await utils.timeout(1000);
            },
            "disabled": () => !app.ws.is_open
        });
        this.show_tv_static = new ui.InputProperty(`<select>`, {
            "name": "show-tv-static-no-livestream",
            "label": "Show TV Static When No Live Stream Selected",
            "default": get_default,
            "data": get_data,
            "options": [[true, "Yes"], [false, "No"]],
        });
        this.darkmode = new ui.InputProperty(`<select>`, {
            "name": "darkmode",
            "label": "Dark Mode",
            "default": get_default,
            "data": get_data,
            "options": [[true, "Yes"], [false, "No"], ["auto", "Auto"]],
        });
        this.reset = new ui.Button("<button>Reset All Settings</button>", {
            "click_async": async () => {
                this.content.properties.forEach(p => p.reset(true));
                this.reset.override_content_temporarily("Done!", 1000);
                await utils.timeout(1000);
            },
        });

        var layout = [
            [this.username],
            [this.font_sizes],
            [this.font_styles],
            [this.darkmode],
            [this.show_gifts],
            [this.show_avatars],
            [this.show_comment_timestamps],
            [this.message_audio],
            [this.audio_volume],
            [this.show_blocked_comments],
            IS_CHAT_MODE ? null : [this.autoplay],
            // [this.video_below_chat],
            IS_CHAT_MODE ? null : [this.show_tv_static],
            "---------",
            [this.refresh_chat],
            IS_CHAT_MODE ? null : [this.scan_livestreams],
            [this.reset]
        ].filter(r => r);

        this.content.layout = layout;

        this.content.on("change", (e) => {
            if (!e.name || !e.trigger) return;
            app.settings.set(e.name, e.value);
        })
    }
}

class UsersInterface extends Overlay {
    constructor() {
        super({
            header: () => `Users (${app.total_users})`,
        });
        this.content.elem.classList.add("active-users");
        // this.internal_wrapper.append($(`<h5>Internal Users</h5>`)[0]);
        this.internal_elem = $(`<ul class="internal-users"></ul>`)[0]
        this.external_elem = $(`<ul class="external-users"></ul>`)[0]
        this.content.append(this.internal_elem, this.external_elem);

        this.on("update", () => {
            var clients = utils.sort(Object.values(app.$.clients), c => (c.user.username || c.ip_hash), c => -c.init_ts);
            var client_groups = [...utils.group_by(clients, c => c.ip_hash).values()];
            dom.rebuild(this.internal_elem, client_groups, {
                // selector: ".slick-slide",
                add: (item, elem, i) => {
                    if (!elem) {
                        elem = $(`<li></li>`)[0];
                        var c = item.find(c => c.user.username) || item[0];
                        var username = c.user.username || `Anonymous`;
                        var title = $(`<span class="username ui-fold" data-folded="1"><b>${username}</b></span>`)[0];
                        if (c.user.username) title.classList.add("logged-in");
                        elem.append(title);
                        title.onclick = () => {
                            if (title.dataset.folded) delete title.dataset.folded;
                            else title.dataset.folded = "1";
                            $(content.elem).slideToggle(200);
                        }
                        var content = new ui.UI($(`<ul class="user-data"></ul>`)[0]);
                        content.append(
                            new InfoLine("Logged In", c.user.username ? "Yes" : "No"),
                            new InfoLine("Session Duration", () => {
                                return utils.time_delta_readable(c.init_ts - app.$._now)
                            }),
                            new InfoLine("Display Names", () => {
                                if (!app.display_name_map[c.ip]) return "-";
                                return [...app.display_name_map[c.ip]].join(", ");
                            }),
                        );
                        elem.append(content);
                        append_client_info(content, c);
                        $(content.elem).hide();
                        // title.onclick();
                    }
                    return elem;
                },
                id_callback: (item) => item[0].ip_hash,
            });
            this.external_elem.innerHTML = "";
            for (var k in app.$.livestreams) {
                var ls = app.$.livestreams[k];
                if (ls.user_count && ls._num_unique_clients) {
                    this.external_elem.append(...$(`<li>${ls.host}: ${ls._num_unique_clients.toLocaleString()}</li>`))
                }
            }
        });
    }
}
class CommentReportInterface extends Overlay {
    constructor(id) {
        super({
            header: `Report Comment`,
        });

        this.comment_line = new InfoLine("Comment", () => {
            if (!id) return;
            var comment = app.chat.entries[id];
            return `<i>${comment.$.text}</i>`;
        }, true);
        this.content.append(this.comment_line);

        this.reason = new ui.TextAreaProperty({
            "name": "reason",
            "label": "Reason",
            "placeholder": "Reason",
            "reset": false,
            "textarea.max_length": 512,
            "textarea.show_count": true,
            "textarea.rows": 3,
            "textarea.grow": true,
            "validators": [ui.validators.not_empty],
        });
        this.content.append(this.reason);

        var report_button = new ui.Button(null, {
            disabled: () => !this.content.is_valid,
            content: "Report",
            click_async: async () => {
                report_button.override_content_temporarily(`Sending <i class="fas fa-spinner fa-pulse"></i>`);
                await app.request("report_comment", [id, this.reason.value]).then(() => {
                    this.reason.set_value("");
                    app.chat.overlay_container.hide();
                }).catch((e) => {
                    console.error(e);
                })
                report_button.override_content_temporarily("Done!", 1000);
            }
        });
        this.content.append(report_button);
    }
}

function get_location(ip) {
    // ip = ip.replace(/^\:\:ffff\:([\d\.]+)$/, "$1");
    if (ip === "::1" || ip.endsWith("127.0.0.1")) ip = "8.8.8.8"; // for me when testing locally
    if (!app.$.location_history[ip]) {
        app.$.location_history[ip] = app.request("ip_to_location", [ip])
            .then(data => {
                data.html = (data.country) ? `${data.country}, ${data.regionName || "Unknown"}, ${data.city || "Unknown"} [${data.isp || "-"}]` : `-`;
                return data;
            })
    }
    return app.$.location_history[ip];
}
async function get_client_history(ip_hash) {
    if (!app.$.client_history[ip_hash]) {
        // var client = Object.values(app.$.clients).find(c=>c.ip_hash == ip_hash);
        // if (!client) {
        var client = await app.request("get_client_info", [ip_hash]);
        // }
        app.$.client_history[ip_hash] = client;
    }
    return app.$.client_history[ip_hash];
}

function get_flag_emoji(countryCode) {
    const codePoints = String(countryCode).toUpperCase().split('').map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}
function format_date(ts) {
    return new Date(ts).toLocaleString() + `<br>[${utils.time_diff_readable(ts)}]`;
}
class CommentInfoInterface extends Overlay {
    constructor(id) {
        super({
            header: () => `Comment #${id}`,
        });
        this.comment_id = id;
    }

    async _show() {
        var id = this.comment_id;
        this.content.elem.innerHTML = "";
        var c = app.chat.entries[id];
        var client_history;
        if (c.$.ip_hash) {
            client_history = await get_client_history(c.$.ip_hash);
        }
        var ls = app.$.livestreams[c.$.livestream_id];
        this.content.append(
            new InfoLine("Time Sent", () => format_date(c.ts)),
            new InfoLine("Origin", url_to_link(ls ? ls.url : window.location.origin))
        )
        if (c.$.text) this.content.append(new InfoLine("Comment", `<i>${c.$.text}</i>`));
        if (c.$.username) {
            this.content.append(new InfoLine("Username", `<a href="/user/${c.$.username}" target="_blank">${c.$.username}</a>`));
        }
        if (c.$.author) this.content.append(new InfoLine("Display Name", c.$.author));

        if (client_history && client_history.length) {
            if (client_history[0].username) this.content.append(new InfoLine("Registered Username", utils.try_catch(() => client_history[0].user.username) || "-"));
            this.content.append(new InfoLine("Connection Status", () => Object.values(app.$.clients).find(c => c.ip_hash == client_history[0].ip_hash) ? "Online" : "Offline"));
            append_client_info(this.content.elem, client_history[0]);
        }
    }
}

function url_to_link(url) {
    var text = utils.try_catch(() => new URL(url).hostname) || url;
    return `<a href="${url}" target="_blank">${text}</a>`
}

function append_client_info(parent, c) {
    parent.append(new InfoLine("Blocked", () => (app.is_blocked(c)) ? "Yes" : "No", true)); // c.client_id != app.$.client_id
    if (app.$._client.user.is_admin && c.ip) {
        parent.append(new InfoLine("IP Address", c.ip));
    }
    if (c.ip_hash) {
        parent.append(new InfoLine("IP Hash", c.ip_hash));
    }
    if (c.ip) {
        parent.append(new InfoLine("Geo-IP Location", async () => (await get_location(c.ip)).html));
    }

    if (app.$._client.user.is_admin) {
        if (c.ip) {
            parent.append(new ui.Button(null, {
                "content": () => `${c.ip in app.$.chat_blocklist ? "Unblock" : "Block"} IP Address`,
                "click": () => app.chat_blocklist_toggle(c.ip)
            }));
        }
        if (c.username) {
            parent.append(new ui.Button(null, {
                "content": () => `${c.username in app.$.chat_blocklist ? "Unblock" : "Block"} Username`,
                "click": () => app.chat_blocklist_toggle(c.username)
            }));
        }
        /* if (c.fc2) {
            parent.append(new ui.Button(null, {
                "content":()=>`${c.fc2.encrypted_user_id in app.$.chat_blocklist ? "Unblock" : "Block"} FC2 User ID`,
                "click":()=>app.chat_blocklist_toggle(c.fc2.encrypted_user_id)
            }));
        } */
    }
}
/* class PollInterface extends Overlay {
    get options() { return Array.from(this.options_container.children) }
    get num_options() { return this.options_container.childElementCount; }

    constructor() {
        super({
            header: "Edit Poll",
        });
        
        var row = this.content_elem.append(new ui.FlexRow());
        this.question = new ui.InputProperty(`<textarea style="resize:none" maxlength="128"></textarea>`, {
            "name": "question",
            "label": "Question",
            "default":"",
            "placeholder":"Question",
            "reset": false,
        });
        this.question.validators.push(ui.VALIDATORS.not_empty);
        new dom.AutoSizeController(this.question.input);

        var row = this.content_elem.append(new ui.FlexRow());
        this.options_prop = new ui.InputProperty(`<div class="options-wrapper"><div class="options"></div><button class="button add-option" title="Add Option"><i class="fas fa-plus"></i></button></div>`, {
            "name": "options",
            "label": "Options",
            "default":[],
            "reset": false,
        });
        this.options_container = this.options_prop.elem.querySelector(".options")
        this.add_option_button = this.options_prop.elem.querySelector(".add-option");
        this.add_option_button.addEventListener("click", ()=>{
            this.add_option(true);
        })
        row.append(this.options_prop);
        
        var row = this.content_elem.append(new ui.FlexRow());
        this.time_limit_select = new ui.InputProperty(`<select>`, {
            "name": "time-limit",
            "label": "Time Limit",
            "default":300,
            "options": [60, 120, 300, 600, 1200, 1800, 3600].map(s=>[s,utils.seconds_to_human_readable_str(s)]),
            "reset": false,
        });
        row.append(this.time_limit_select);
        
        this.send_button = new ui.Button("<button>Send</button>", {
            "disabled":()=>this.is_valid,
            "click":()=>{
                // send_poll()
                this.reset();
                this.__parent.toggle(false);
            }
        })
        this.delete_button = new ui.Button("<button>Delete</button>", {
            "click":()=>{
                if (confirm("Are you sure?")) {
                    // delete_poll()
                    this.reset();
                }
            }
        })
        this.delete_button.elem.classList.add("delete");

        this.footer_elem.append(this.send_button, this.delete_button);

        this.elem.addEventListener("keydown", (e)=>{
            var option = e.target.closest(".option");
            if (e.key == "Enter") {
                if (this.question.input === e.target) {
                    this.options_container.querySelector("textarea").focus();
                } else if (option.nextSibling) {
                    option.nextSibling.querySelector("textarea").focus();
                } else {
                    this.add_option(true);
                }
            } else if ((e.key == "Backspace" || e.key == "Delete") && option && !e.target.value && this.num_options > PollInterface.min_options) {
                var next = e.key == "Backspace" ? (option.previousSibling || option.nextSibling) : (option.nextSibling || option.previousSibling);
                if (next) next.querySelector("textarea").focus();
                this.remove_option(option);
            } else if (e.key == "ArrowUp" && option) {
                if (option.previousSibling) option.previousSibling.querySelector("textarea").focus();
            } else if (e.key == "ArrowDown" && option) {
                if (option.nextSibling) option.nextSibling.querySelector("textarea").focus();
            } else {
                return;
            }
            e.preventDefault();
            return false;
        });
        this.sortable = new Sortable(this.options_container, {
            animation: 150,
            revertOnSpill: true,
            handle: ".handle",
            draggable: ".option",
            onUpdate: ()=>this.update_options(),
        });
        this.reset();
    }

    update_options() {
        var options = this.options;
        options.forEach((e,i)=>{
            e.querySelector("textarea").placeholder = `Option ${i+1}`;
            e.querySelector("button.delete").disabled = (options.length <= PollInterface.min_options);
        });
        this.add_option_button.disabled = (options.length >= PollInterface.max_options);
    }

    remove_option(option) {
        option.querySelector("textarea").__autosize__.destroy();
        option.remove();
        this.update_options();
    }

    add_option(focus = false) {
        if (this.num_options >= PollInterface.max_options) return;
        var option = $(`<div class="option"><i class="fas fa-grip-lines handle"></i><textarea rows="1" maxlength="128"></textarea><button class="delete" title="Delete Option"><i class="fas fa-times"></i></button></div>`)[0];
        var textarea = option.querySelector("textarea");
        // option.textarea = textarea;
        // this.validator.add(textarea, ()=>!!textarea.value);
        new dom.AutoSizeController(textarea);
        option.querySelector("button").addEventListener('click', ()=>this.remove_option(option));
        this.options_container.append(option);
        this.update_options();
        if (focus) textarea.focus();
    }

    reset() {
        while (this.num_options < PollInterface.min_options) this.add_option();
        while (this.num_options > PollInterface.min_options) this.remove_option(this.options_container.lastElementChild);
        Array.from(this.options_container.querySelectorAll("textarea")).forEach(e=>{
            e.value = "";
            if (e.__autosize__) e.__autosize__.update();
        });
    }

    async show() {
        this.reset();
        await super.show();
    }
}
PollInterface.min_options = 2;
PollInterface.max_options = 8; */

class ChatHeader extends ui.UI {
    constructor(el) {
        super(el, {
            "hidden": !SHOW_CHAT_HEADER,
        });

        /* this.select = new ui.InputProperty(`<select>`, {
            "label": "Chat:",
            "inline": true,
            "options": ()=>[
                {text: "-", value: "", hidden: true},
                {
                    group: "Chats",
                    options: [
                        ...Object.values(app.$.chats).map(chat=>({text: chat.name, value: chat.id}))
                    ]
                }
            ],
            "reset": false,
        });
        this.select.on("change", (e)=>{
            if (e.trigger) app.chat_connect(this.select.value);
        });
        this.append(this.select); */
        var os = dom.OverlayScrollbars(this.elem, {});
        var inner = os.elements().viewport
        inner.classList.add("chat-header");

        this.on("update", () => {
            /* if (this.select.value != app.$._chat.id) {
                this.select.set_value(app.$._chat.id);
            } */
            dom.rebuild(inner, Object.values(app.$.chats), {
                add: (chat, el, index) => {
                    if (!el) {
                        el = $(`<button class="chat-tab"></button>`)[0];
                        el.onclick = () => app.chat_connect(chat.id);
                    }
                    var count = chat._num_unique_clients;
                    el.title = `${chat.name} (${count} Users)`;
                    dom.set_inner_html(el, `${chat.name} (${count})`);
                    el.classList.toggle("active", chat.id == app.$._chat.id);
                    // el.classList.toggle("new-messages", );
                    return el;
                }
            });
        });
    }
}

class ChatFooter extends ui.UI {
    constructor(el) {
        super(el);

        let col1 = $(`<div class="buttons">`)[0];
        let col2 = $(`<div class="buttons">`)[0];
        this.status_el = $(`<span class="connection-status status-icon" data-bs-toggle="tooltip"><i class="fas fa-plug"></i></span>`)[0];

        this.user_count_button = new ui.Button(`<button><i class="fas fa-users"></i><span></span></button>`, {
            class: "live-button-icon user-count",
            title: () => `Total users: ${app.$._chat._num_unique_clients.toLocaleString()}`,
            click: () => {
                app.chat.overlay_container.toggle("users", () => new UsersInterface());
            },
            render: () => {
                let user_count = app.total_users;
                let num_elem = this.user_count_button.elem.querySelector("span");
                num_elem.innerHTML = user_count.toLocaleString();
            }
        });
        col1.append(this.status_el, this.user_count_button);

        var fullscreen_button = new ui.Button(`<button><i class="fas fa-expand"></i></button>`, {
            "class": "live-button-icon fullscreen",
            "title": () => `Toggle fullscreen`,
            // "hidden": () => mobile_detect.is("Firefox") && (mobile_detect.tablet() || mobile_detect.phone()),
            "click": () => {
                window.focus();
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else {
                    app.elem.requestFullscreen().catch((e) => console.error(e));
                }
                // app.viewer.debounced_focus();
            }
        });
        var popout_button = new ui.Link(`<a><i class="far fa-window-restore"></i></a>`, {
            "class": "button live-button-icon popout",
            "title": () => `Popout Chat Window`,
            "click": (e) => {
                e.preventDefault();
                app.toggle_chat_popout();
            },
            "href": "/live/?chat=1",
            "hidden": IS_CHAT_MODE
        });
        var config_button = new ui.Button(`<button><i class="fas fa-cog"></i></button>`, {
            "class": "live-button-icon config",
            "title": () => `Settings...`,
            "click": (e) => {
                app.chat.overlay_container.toggle("settings", () => new ChatSettingsInterface());
            }
        });
        this.chat_char_count_el = $(`<span class="char-count" title="Message Length"></span>`)[0];
        col2.append(fullscreen_button, popout_button, config_button, this.chat_char_count_el);

        this.elem.append(col1, col2);

        this.on("update", () => {
            var status = [1, 2, 0, 0][app.ws.ready_state];
            dom.set_attribute(this.status_el, "data-status", status);
            dom.set_attribute(this.status_el, "title", `${connection_status[status]}`);
        });
    }
}

class CooldownButton extends ui.Button {
    #cooldown_hash;
    constructor(elem, settings) {

        super(elem, {
            "cooldown.type": "text",
            ...settings,
            "disabled": () => (settings.disabled)() || has_cooldown(),
        });

        var type = this.get_setting("cooldown.type");
        var ring_wrapper_el = $(`<div class="ring"></div>`)[0];
        var text_el = $(`<span></span>`)[0];
        this.elem.append(ring_wrapper_el);
        var t = 0;
        var interval_id, timeout_id;

        var get_cooldown = () => {
            return app.$._user._get_cooldown(type) / 1000;
        };
        var has_cooldown = () => get_cooldown() > 0;

        var update_text = () => {
            var t = get_cooldown();
            var t_secs = Math.round(t);
            var t_mins = Math.round(t/60);
            text_el.innerHTML = t_secs > 60 ? String(t_mins)+"m" : (t < 1.5) ? "" : String(t_secs);
        };

        var toggle_ring = (show) => {
            clearInterval(interval_id);
            clearTimeout(timeout_id);
            dom.remove_children(ring_wrapper_el);
            t = get_cooldown();

            if (!show) return;
            if (!t) return;

            var d = app.$.conf.chat_cooldown[type];
            var p = t / d;
            var ring_svg = create_svg_ring(3, 9, p, t);
            ring_wrapper_el.append(ring_svg, text_el);
            this.elem.classList.toggle("cooldown", true);
            interval_id = setInterval(() => update_text(), 1000);
            timeout_id = setTimeout(() => {
                clearInterval(interval_id);
                dom.remove_children(ring_wrapper_el);
                update_text();
                this.update();
                this.elem.classList.toggle("cooldown", false);
            }, t * 1000);
            update_text();
        }

        this.on("update", () => {
            var hash = app.$._user.cooldown[type];
            if (this.#cooldown_hash == hash) return;
            this.#cooldown_hash = hash;
            toggle_ring(true);
        });
    }
}

class ChatInput extends ui.UI {
    #sending = {
        text: false,
        gift: false,
    };
    is_focussed = false;
    input_length = 0;
    input_valid = false;
    constructor(el) {
        super(el);

        this.elem.dataset.mode = "text";
        this.input_wrapper_el = $(`<div class="chat-input"></div>`)[0];
        this.inner_el = $(`<div class="chat-input-inner"></div>`)[0];
        this.input_wrapper_el.append(this.inner_el);
        this.elem.append(this.input_wrapper_el);

        this.editor_el = $(
            `<div class="editor">
                <div class="text-ui">
                    <textarea class="text-input"></textarea>
                    <span class="text-input"></span>
                    <label class="placeholder">Send a message</label>
                </div>
            </div>`
        )[0];

        this.input_fake = this.editor_el.querySelector("span.text-input");
        /** @type {HTMLTextAreaElement} */
        this.input = this.editor_el.querySelector("textarea.text-input");
        this.placeholder_el = this.editor_el.querySelector(".placeholder");

        this.send_button = new CooldownButton(`<button><i class="fas fa-paper-plane"></i></button>`, {
            class: "live-button-icon send-message",
            title: `Send Message`,
            click: () => this.try_send(),
            disabled: () => !!(app.chat.overlay_container.overlay || !this.input_valid || !app.ws.is_open),
            "cooldown.type": "text",
        });
        this.gift_button = new CooldownButton(`<button><i class="fas fa-gift"></i></button>`, {
            class: "live-button-icon send-gift",
            title: `Send Gift`,
            disabled: () => !!(app.chat.overlay_container.overlay || !app.ws.is_open),
            "cooldown.type": "gift",
        });

        var buttons = $(`<div class="chat-input-buttons"></div>`)[0];
        buttons.append(this.send_button, this.gift_button);

        this.inner_el.append(
            // this.embed_dropdown,
            this.editor_el,
            buttons
        );

        new ResizeObserver(() => this.update()).observe(this.elem);

        /* this.embed_dropdown = new ui.Button(`<button><i class="fas fa-plus-square"></i></button>`, {
            title: `Embed...`,
            click: utils.noop,
            mousedown: ()=>false,
            hidden: true,
            disabled: ()=>!app.ws.is_open,
        }); */

        // popover(this.embed_dropdown.elem, ()=>{
        //     var elem = $(`<div class="dropdown-menu">
        //     <button class="dropdown-item new-poll"><i class="fas fa-poll"></i>Poll</button>
        //     </div>`)[0];
        //     elem.querySelector(".new-poll").onclick = ()=>this.toggle_overlay("poll");
        //     // elem.querySelector(".new-image").onclick = ()=>this.toggle_overlay("image");
        //     return elem;
        // }, {parent:this.$chat_ui_wrapper[0]});

        var get_cooldown = (gift) => {
            return app.$._user._get_cooldown(gift.type) || app.$._user._get_cooldown("gift");
        }

        var process = (gift) =>{
            return {
                icon: gift.icon,
                label: ()=>{
                    var cd = get_cooldown(gift);
                    return (cd > 0) ? gift.label+` (${utils.ms_to_timespan_str(cd)})` : gift.label;
                },
                disabled: ()=>get_cooldown(gift) > 0,
                click:()=>this.try_send(gift)
            }
        };

        var menu = new dom.DropdownMenu({
            target: this.gift_button.elem,
            trigger: "click",
            items: gifts.map(process),
            parent: this.input_wrapper_el,
            tick: 1000,
        });

        this.on("update", () => {
            this.input_fake.innerHTML = this.input.value || `&nbsp;`;
            this.placeholder_el.style.display = this.input.value ? "none" : "";
            app.chat.footer.chat_char_count_el.textContent = `(${this.input_length}/${MAX_COMMENT_LENGTH})`;
            this.input.disabled = !!(!app.ws.is_open || app.chat.overlay_container.overlay);
            this.input.style.height = `${this.input_fake.offsetHeight}px`;
            app.elem.style.setProperty("--live-chat-input-height", `${this.elem.offsetHeight}px`);
        });

        this.input_valid = false;

        this.input.addEventListener("keydown", (e) => {
            if (e.key == "Enter") { // && !e.shiftKey
                e.preventDefault();
                this.try_send();
                return false;
            }
        });

        ["paste", "input", "propertychange"].forEach(ev => this.input.addEventListener(ev, () => {
            this.#update_input(this.input.value);
            app.viewer.debounced_focus();
        }));

        var blur_timeout;
        var focused = false;

        var focus = ()=>{
            focused = true;
            this.input.focus({preventScroll:true});
            app.viewer.debounced_focus();
        };
        this.elem.addEventListener("focusin", (e) => {
            e.preventDefault();
            clearTimeout(blur_timeout);
            var focused_el = document.activeElement;
            if (focused_el == this.input || app.chat.is_floating) {
                app.chat.toggle_floating(true);
                focus();
            }
        });
        this.elem.addEventListener("mousedown", (e)=>{
            if (e.target != this.input) {
                e.preventDefault();
            }
            focus();
        });
        this.elem.addEventListener("focusout", (e) => {
            e.preventDefault();
            clearTimeout(blur_timeout);
            blur_timeout = setTimeout(() => {
                focused = false;
                app.chat.toggle_floating(false);
                this.input.blur();
            }, 100);
        });
        /* this.input.addEventListener("mousedown", (e)=>{
            update_input_focus(true);
        });
        this.input.addEventListener("click", (e)=>{
            update_input_focus(true);
            // e.preventDefault();
            // e.stopPropagation();
        }); */

        /* document.documentElement.addEventListener("mousedown", (e)=>{
            if (this.elem !== e.target && !this.elem.contains(e.target)) {
                update_input_focus(false);
            }
        }); */

        // let viewport_change = ()=>{
        //     // if (document.activeElement != this.input) return;
        //     // update_input_focus(true);
        //     app.viewer.debounced_focus();
        // };
        // let debounced_viewport_change = utils.debounce(viewport_change, 100);
        // window.addEventListener("resize", debounced_viewport_change);
    }

    /** @param {string} e */
    #update_input(text) {
        var { text, length, valid } = sanitize_comment(text);
        this.input_valid = valid;
        this.input_length = length;
        if (this.input.value != text) this.input.value = text;
        this.update();
    }

    async try_send(gift) {
        var type = gift ? "gift" : "text";
        if (this.#sending[type]) return;
        if (!app.ws.is_open) {
            console.warn("Websocket closed.");
            return;
        }

        // if during cooldown return!
        if (app.$._user._get_cooldown(type)) return;

        var c = {};
        if (gift) {
            c.gift = gift.type;
            c.rand = Math.round(Math.random() * Number.MAX_SAFE_INTEGER);
            if (gift.special) c.special = true;
        } else {
            var valid = true;
            var text = this.input.value.trim();
            ({ valid, text } = sanitize_comment(text));
            if (!valid) {
                console.error("Invalid comment:", text);
                return;
            }
            c.text = text;
        }
        this.#sending[type] = true;
        app.send_chat(c)
            .catch((e) => {
                console.error(e);
                return false;
            })
            .then((res) => {
                if (!gift && res) {
                    this.#update_input("");
                    // if (app.is_touch) this.input.blur();
                }
                if (!res) console.error("Chat send failed.");
                // if (!res) app.$._user.cooldown[type] = 0;
                this.#sending[type] = false;
                if (res) {
                    requestAnimationFrame(() => {
                        app.chat.scroll_to_bottom(true);
                    });
                }
            })
        this.emit("submit");
        app.$._user.cooldown[type] = app.$.conf.chat_cooldown[type];
        this.update();
    }
}


class ViewerUI extends ui.UI {
    #layout_hash;
    // #ts = Date.now();
    // #focus_init_timeout;
    constructor(elem) {
        super(elem);
        this.views_container_el = $(`<div class="views-container"></div>`)[0];
        elem.append(this.views_container_el);

        this.debounced_resize = utils.debounce(this.resize.bind(this), 100);
        this.debounced_focus = utils.debounce(this.focus.bind(this), 100);
        new ResizeObserver(() => this.debounced_resize()).observe(this.elem);
        // window.addEventListener("resize", ()=>this.debounced_resize());
        this.on("update", () => {
            this.rebuild();
        });
    }

    setup_none() {
        if (!this.empty_el) {
            this.empty_el = $(`<div class="livestream-none"><div></div><div class="message"><b>No Live Stream Selected</b></div></div>`)[0];
        }

        var w = Math.round(this.elem.offsetWidth / 2);
        var h = Math.round(this.elem.offsetHeight / 2);
        var visible = app.settings.get("show-tv-static-no-livestream");
        var __hash = JSON.stringify([visible, w, h]);

        if (this.empty_el.__hash !== __hash) {
            this.empty_el.__hash = __hash;
            var c = this.empty_el.children[0];
            dom.remove_children(c);
            if (this.empty_el && this.empty_el.__nf) cancelAnimationFrame(this.empty_el.__nf);
            if (visible && w > 0 && h > 0) {
                var noise_canvas = document.createElement("canvas");
                noise_canvas.width = w;
                noise_canvas.height = h;

                var shadow = $(`<div class="shadow-overlay">`)[0]
                var ocanvas = document.createElement("canvas");
                ocanvas.width = w * 2;
                ocanvas.height = h * 2;
                var octx = ocanvas.getContext("2d", { alpha: false, willReadFrequently: true });
                var idata = octx.createImageData(ocanvas.width, ocanvas.height);
                var buffer32 = new Uint32Array(idata.data.buffer);
                var noise = (ctx) => {
                    var len = buffer32.length - 1;
                    while (len--) buffer32[len] = Math.random() < 0.5 ? 0 : -1 >> 0;
                    ctx.putImageData(idata, 0, 0);
                }
                noise(octx);
                var ctx = noise_canvas.getContext("2d", { alpha: false });
                c.append(noise_canvas, shadow);
                var __loop = () => {
                    if (noise_canvas.isConnected) {
                        var x = (w * Math.random()) | 0;
                        var y = (h * Math.random()) | 0;
                        ctx.drawImage(ocanvas, -x, -y);
                    }
                    this.empty_el.__nf = requestAnimationFrame(__loop);
                }
                __loop();
            }
        }
    }

    rebuild() {
        var leftovers = new Set([...this.views_container_el.children]);
        var i = 0;
        if (app.current_livestreams.length) {
            for (var ls of app.current_livestreams) {
                if (!ls._view.elem.parentElement) {
                    this.views_container_el.append(ls._view.elem);
                }
                ls._view.elem.style.order = i;
                leftovers.delete(ls._view.elem);
                i++;
            }
            for (var elem of leftovers) {
                elem.remove();
            }
        } else {
            this.setup_none();
            dom.set_children(this.views_container_el, [this.empty_el]);
        }

        var layout_hash = JSON.stringify(app.current_livestreams.map(ls => ls.id));
        if (this.#layout_hash !== layout_hash) this.resize();
        this.#layout_hash = layout_hash;

    }

    focus(smooth = true) {
        if (app.is_fullscreen) return;
        if (!app.is_mobile && !app.is_mini) return;
        var rect = app.chat_and_video_wrapper_el.getBoundingClientRect();
        if (rect.y >= 0 && rect.bottom <= window.innerHeight) return;
        // let time_since_creation = Date.now() - this.#ts;
        // if (time_since_creation < WAIT_UNTIL_FIRST_FOCUS) {
        //     if (!this.#focus_init_timeout) {
        //         this.#focus_init_timeout = setTimeout(() => this.focus(smooth), WAIT_UNTIL_FIRST_FOCUS - time_since_creation);
        //     }
        //     return;
        // }
        // var h = window.innerHeight;
        // h = window.screen.height;
        // if (window.innerHeight < rect.height) return;
        var top;
        var offset = 0;
        // if (cabtv.nav.height) offset += cabtv.nav.height || 0;
        // var announcements_bar_el = document.querySelector("#announcements-bar");
        // if (announcements_bar_el) offset += announcements_bar_el.getBoundingClientRect().height;
        if ((window.innerHeight - offset) > rect.height) {
            top = rect.top - offset; // top
        } else {
            top = rect.bottom - window.innerHeight; // bottom
        }
        if (top) {
            app.root_scroll_el.scrollBy({ top, behavior: smooth ? "smooth" : "instant" });
        }
    }

    resize() {
        let container_width = this.elem.offsetWidth;
        let container_height = this.elem.offsetHeight;
        var num_rows = false;
        var fit = true;

        let livestreams = app.current_livestreams;
        let num_videos = livestreams.length;
        let layout = {
            area: 0,
            cols: 0,
            rows: 0,
            width: 0,
            height: 0
        };
        for (let i = 0; i < num_videos; i++) {
            let cols, rows;
            let ls = livestreams[i];
            if (num_rows) {
                rows = parseInt(num_rows);
                cols = Math.ceil(num_videos / rows);
            } else {
                cols = i + 1;
                rows = Math.ceil(num_videos / cols);
            }
            let ar = 4 / 3;
            let width = container_width / cols;
            let height = container_height / rows;
            if ((height / width) > ar) {
                height = width / ar;
            } else {
                width = height * ar;
            }
            let area = width * (height - ls._view.footer_el.offsetHeight); // - ls.__ui.header_el.offsetHeight);
            if (area > layout.area) {
                layout = {
                    area,
                    width,
                    height,
                    rows,
                    cols
                };
            }
            if (num_rows) break;
        }

        for (let i = 0; i < num_videos; i++) {
            var ls = livestreams[i];
            var row = Math.floor(i / layout.cols);
            var col = i % layout.cols;
            var num_cols_on_row = Math.min(layout.cols, num_videos - (row * layout.cols));
            var col_width = layout.width;
            var row_height = layout.height;
            if (fit) {
                row_height = container_height / layout.rows;
                col_width = container_width / layout.cols;
            }
            var top = (row + 1) * (container_height - row_height * layout.rows) / (layout.rows + 1) + (row * row_height);
            var left = (col + 1) * (container_width - col_width * num_cols_on_row) / (num_cols_on_row + 1) + (col * col_width);

            Object.assign(ls._view.elem.style, {
                "position": "absolute",
                "width": `${col_width}px`,
                "height": `${row_height}px`,
                "top": `${top}px`,
                "left": `${left}px`
            });

            if (ls._view.iframe_el) {
                var car = (ls._view.content_el.offsetWidth / ls._view.content_el.offsetHeight);
                var far = ls._view.fixed_aspect_ratio;
                var style = { "aspect-ratio": "", "width": "", "height": "" };
                if (far) {
                    style["aspect-ratio"] = far;
                    if (car > far) {
                        style.width = "auto";
                        style.height = "100%";
                    } else {
                        style.width = "100%";
                        style.height = "auto";
                    }
                }
                Object.assign(ls._view.iframe_el.style, style);
            }
        }
    }
}

class ChannelManagerUI extends ui.UI {
    /** @type {string} */
    group_id = null;
    /** @type {Record<PropertyKey,LiveStream$[]} */
    groups = {};
    get group() { return LIVESTREAM_GROUPS[this.group_id]; }
    get livestreams() { return this.groups[this.group_id] || []; }
    constructor(elem) {
        super(elem);

        this.channel_groups_el = this.elem.querySelector(".channel-tabs");
        this.no_channels_message_el = this.elem.querySelector(".channels-empty-message");
        this.channels_list_wrapper_el = this.elem.querySelector(".channels-list");
        this.channels_el = this.elem.querySelector(".channels");
        this.slider_el = this.elem.querySelector(".slider");
        this.auto_button = this.elem.querySelector(".button.auto");

        this.channels_el.classList.add("splide");
        this.channels_el.append($(`<div class="splide__track"><ul class="splide__list"></ul></div>`)[0]);
        this.channels_list_el = this.channels_el.querySelector("ul");

        this.slider = new Splide(this.channels_el, {
            perPage: 8,
            perMove: 1,
            arrows: false,
            gap: 10,
            padding: "3rem", // 3rem
            pagination: false,
            focus: "center",
            breakpoints: {
                1600: {
                    perPage: 7,
                },
                1400: {
                    perPage: 6,
                },
                1200: {
                    perPage: 5,
                },
                1000: {
                    perPage: 4,
                },
                800: {
                    perPage: 3,
                },
                600: {
                    perPage: 2,
                },
                400: {
                    perPage: 1,
                },
            }
        });
        this.slider.mount();
        this.slider.Components.Drag.disable();

        this.prev_button = this.slider_el.querySelector("button.slider-prev");
        this.next_button = this.slider_el.querySelector("button.slider-next");
        // shit way of doing it but it works
        var move = (delta) => {
            var next = this.slider.index + delta;
            var min = Math.round(this.slider.options.perPage / 2);
            var max = Math.floor(this.slider.length - 1 - this.slider.options.perPage / 2);
            if (this.slider.index <= min) {
                if (delta < 0) next = 0;
                else next = min;
            }
            if (this.slider.index >= max) {
                if (delta < 0) next = max;
                else next = this.slider.length - 1;
            }
            if (next == this.slider.index) {
                next += delta
            }
            this.slider.go(next);
        };

        this.prev_button.onclick = () => move(-1);
        this.next_button.onclick = () => move(1);

        this.slider.on(["moved", "scrolled", "refresh", "resize", "mounted"], () => this.update_slider_buttons()); // "ei", 
        this.slider.on("overflow", (o) => {
            this.slider_el.classList.toggle("overflow", o);
        })
        /* this.slider.on("dragged", ()=>{
            this.slider.on("move.cabtv", (newIndex, prevIndex, destIndex)=>{
                this.slider.off("move.cabtv")
                var index = destIndex;
                if (prevIndex > destIndex && destIndex < this.slider.options.perPage) {
                    index = 0;
                } else if (prevIndex < destIndex && this.slider.length - 1 - this.slider.options.perPage) {
                    index = this.slider.length - 1;
                }
                if (index != destIndex) {
                    this.slider.go(index)
                }
            })
            console.log(this.slider.index);
        }) */

        window.addEventListener("hashchange", () => {
            this.update()
        });

        this.on("update", () => {
            utils.clear(this.groups);
            for (var id in LIVESTREAM_GROUPS) {
                this.groups[id] = [];
                for (var ls of app.$._livestreams_ordered) {
                    if (LIVESTREAM_GROUPS[id].condition(ls)) this.groups[id].push(ls);
                }
            }
            dom.toggle_display(this.no_channels_message_el, !this.livestreams.length);
            dom.rebuild(this.channel_groups_el, Object.values(LIVESTREAM_GROUPS), {
                add: (group, elem, i) => {
                    if (!elem) {
                        elem = $(`<button class="button"></button>`)[0];
                        elem.onclick = () => this.set_group(group.id);
                    }
                    elem.classList.toggle("active", group.id === this.group_id);
                    elem.classList.toggle("focus", app.current_livestreams.some(ls => ls._group === group));
                    elem.innerHTML = `${utils.capitalize(group.label)} (${this.groups[group.id].length.toLocaleString()})`;
                    return elem;
                }
            });

            var old_children = [...this.channels_list_el.children];
            dom.rebuild(this.channels_list_el, this.livestreams, {
                add: (ls, elem, i) => {
                    ls._thumbnail.elem.dataset.index = i;
                    return ls._thumbnail.elem
                },
            });
            if (!utils.array_equals([...this.channels_list_el.children], old_children)) {
                this.slider.refresh();
            }
            this.update_slider_buttons();
            this.auto_button.classList.toggle("focus", app.is_auto);
            this.auto_button.href = app.is_auto ? `#${app.auto_id}` : `#${AUTO}`;
        });
    }

    update_slider_buttons() {
        // const next = this.slider.Components.Controller.getNext();
        // const prev = this.slider.Components.Controller.getPrev();
        this.prev_button.disabled = this.slider.index < this.slider.options.perPage / 2;
        this.next_button.disabled = this.slider.index > this.slider.length - 1 - this.slider.options.perPage / 2;
    }

    set_group(id) {
        if (!id) return;
        var focus_instant = false;
        if (this.group_id != id) {
            this.group_id = id;
            focus_instant = true;
            this.update();
        }
        this.focus(focus_instant)
    }

    focus(instant) {
        var curr = new Set(app.current_livestreams);
        var curr_in_group = this.livestreams.find(ls => curr.has(ls));
        var el = curr_in_group?._thumbnail.elem;
        if (el) {
            var i = +el.dataset.index;
            var speed = app.channel_manager.slider.options.speed;
            if (instant) app.channel_manager.slider.options.speed = 0;
            app.channel_manager.slider.go(i);
            app.channel_manager.slider.options.speed = speed;
        }
    }
}

/** @returns {HTMLElement} */
function create_svg_ring(thickness, radius, percent, time) {
    var circumference = Math.PI * radius * 2;
    var size = radius * 2 + thickness;
    percent = utils.clamp(percent);
    var start = `${(1 - percent) * circumference}px`;
    var end = `${circumference}px`;
    var el = $(`
        <svg width="${size}" height="${size}" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)">
            <circle r="${radius}" cx="${size / 2}" cy="${size / 2}" fill="transparent" stroke="#000" stroke-width="${thickness}px"></circle>
            <circle r="${radius}" cx="${size / 2}" cy="${size / 2}" fill="transparent" stroke="#fff" stroke-width="${thickness}px" stroke-linecap="round" stroke-dashoffset="${start}" stroke-dasharray="${circumference}px" style="--start: ${start}; --end: ${end}; animation: fill-circle ${time}s linear forwards"></circle>
        </svg>
    `)[0];
    return el;
}

class Chat extends ui.UI {
    get first_entry_id() {
        var el = this.entry_container_el.firstElementChild;
        if (el) return +el.getAttribute("data-id");
    };
    get last_entry_id() {
        var el = this.entry_container_el.lastElementChild;
        if (el) return +el.getAttribute("data-id");
    };
    /** @type {ChatEntryBase} */
    get first_entry() { return this.entries[this.first_entry_id]; };
    /** @type {ChatEntryBase} */
    get last_entry() { return this.entries[this.last_entry_id]; };
    /** @param {Element} elem */
    get scroll_bottom() { return this.scroll_elem.clientHeight < this.scroll_elem.scrollHeight ? dom.scroll_pos_from_bottom(this.scroll_elem) : 0; }

    #is_focussed = false;
    #is_floating = false;
    #focus_timeout;
    #is_scrolling_to_bottom = false;
    /** @type {utils.DeferredReady} */
    #deferred_ready = new utils.DeferredReady();

    get ready() { return this.#deferred_ready.ready; }
    get is_focussed() { return this.#is_focussed; }
    get is_floating() { return this.#is_floating; }

    constructor(el) {

        super(el);

        var footer_wrapper_el = this.elem.querySelector(".chat-footer-wrapper");
        var chat_input_wrapper_el = this.elem.querySelector(".chat-input-wrapper");
        var chat_header_wrapper_el = this.elem.querySelector(".chat-header-wrapper");
        var chat_content_wrapper_el = this.elem.querySelector(".chat-inner-wrapper");

        this.footer = new ChatFooter(footer_wrapper_el);

        this.header = new ChatHeader(chat_header_wrapper_el);

        this.input = new ChatInput(chat_input_wrapper_el);

        var inner = $(`<div class="chat-content-inner"></div>`)[0];
        var scroll_outer = $(`<div class="chat-scroll" data-overlayscrollbars-initialize></div>`)[0];
        inner.append(scroll_outer);
        chat_content_wrapper_el.append(inner);

        var os = dom.OverlayScrollbars(scroll_outer, {});
        var scroll_inner = os.elements().viewport;
        this.scroll_elem = scroll_inner;

        this.overlay_container = new OverlayContainer();
        inner.append(this.overlay_container);

        /** @type {Set<dom.DropdownMenu>} */
        this.menus = new Set();

        new ResizeObserver(() => {
            this.update_scroll();
        }).observe(inner);

        this.on("tippy", () => {
            this.update_next_frame();
        });
        this.overlay_container.on("change", () => {
            this.update_next_frame();
        });

        this.chat_scroll_to_bottom_el = $(`<div class="chat-scroll-to-bottom"><span>Chat paused<i class="fas fa-pause"></i></span></div>`)[0];
        this.chat_scroll_to_bottom_el.children[0].onclick = () => {
            this.scroll_to_bottom(true);
        };
        inner.append(this.chat_scroll_to_bottom_el);
        inner.append(this.overlay_container);

        this.user_scroll_detect = new dom.UserScrollDetect(this.scroll_elem);
        this.scroll_elem.addEventListener("scroll", (e)=>{
            // var os_scroll = os?.elements().viewport?.getAttribute("data-overlayscrollbars-viewport")?.includes("scrolling") ?? false;
            // var is_user = this.user_scroll_detect.userScrolling || os_scroll;
            // if (is_user) this.user_scroll_bottom = this.scroll_bottom;
            this.user_scroll_bottom = this.scroll_bottom;
            if (this.scroll_elem.scrollTop == 0) this.try_load_previous_page();
            this.update_next_frame();
        });

        this.dummy_loader_el = $(`<div class="dummy-loader"><i class="fas fa-spinner fa-pulse"></i></div>`)[0];
        this.dummy_loader_el.style.display = "none";
        this.scroll_elem.append(this.dummy_loader_el);
        this.entry_container_el = $(`<div class="chat-container">`)[0];
        this.scroll_elem.append(this.entry_container_el);

        this.reset();

        var check_paused = () => {
            return this.menus.size > 0 || !!this.overlay_container.overlay || (this.user_scroll_bottom > MIN_SCROLL_PAUSE_THRESHOLD) || this.#is_scrolling_to_bottom;
        }

        this.on("update", () => {
            dom.toggle_class(this.elem, "client-blocked", app.is_blocked(app.$._client || {}));

            var font_size = app.settings.get("chat-font-size");
            var font_style = app.settings.get("chat-font-style");
            var show_blocked = app.settings.get("show-blocked-comments");
            var show_avatars = app.settings.get("show-avatars");
            this.elem.style.setProperty("--font-size", `${font_size}px`);
            this.elem.style.setProperty("--font-style", font_style);
            this.elem.classList.toggle("show-blocked", show_blocked);
            this.elem.classList.toggle("show-avatars", show_avatars);
        });

        var paused_ticks = 0;

        setInterval(()=>{
            var is_paused = check_paused();
            if (is_paused) paused_ticks++;
            else paused_ticks = 0;
            this.elem.toggleAttribute("data-showing-overlay", !!this.overlay_container.overlay);
            this.elem.toggleAttribute("data-pause", paused_ticks > 1);
            this.#deferred_ready.state = !is_paused;
        }, 100);

        this.on("render", () => {
            this.dummy_loader_el.style.display = this.is_last_page ? "none" : "";
        });
    }

    toggle_floating(value) {
        // if (!app.is_touch) return;
        // app.elem.classList.toggle("chat-input-focused", value);
        // this.elem.classList.toggle("floating", value);
        // app.root_scroll_el.classList.toggle(app.disable_scroll_class, value);
        // clearTimeout(this.#focus_timeout);
        // if (value) {
        //     if (!this.#is_focussed) app.viewer.debounced_focus();
        //     this.#is_focussed = true;
        // } else {
        //     this.#focus_timeout = setTimeout(() => {
        //         this.#is_focussed = false;
        //     }, 200);
        // }
        // if (this.#is_floating !== value) {
        //     this.update_scroll(0);
        // }
        // this.#is_floating = value;
    }

    update_scroll(scroll) {
        if (scroll === undefined) scroll = this.user_scroll_bottom;
        if (this.#is_scrolling_to_bottom) $(this.scroll_elem).stop();
        if (scroll < MIN_SCROLL_PAUSE_THRESHOLD) scroll = 0;
        dom.scroll_pos_from_bottom(this.scroll_elem, scroll);
        this.user_scroll_bottom = scroll;
    }

    async scroll_to_bottom(animate) {
        if (this.scroll_bottom > MIN_SCROLL_PAUSE_THRESHOLD && animate) {
            this.#is_scrolling_to_bottom = true;
            await $(this.scroll_elem).animate({ scrollTop: this.scroll_elem.scrollHeight - this.scroll_elem.clientHeight }, {
                duration: 400
            }).promise();
            this.#is_scrolling_to_bottom = false;
        }
        this.update_scroll(0);
        this.update();
    }

    get MAX_CHAT_ENTRIES() {
        // return dom.has_touch_screen() ? 100 : 150;
        return 100;
    }

    async refresh() {
        var data = await app.request("get_chat_events");
        this.reset();
        this.apply_historic_events(data);
    }

    reset() {
        dom.remove_children(this.entry_container_el);
        /** @type {Record<PropertyKey,ChatEntryBase>} */
        this.entries = {};
        /** @type {Record<PropertyKey,any[]>} */
        this.pending_updates = {}
        this.user_scroll_bottom = 0;
        this.is_last_page = false;
        this.initialized = false;
        this.update_next_frame();
    }

    /** @param {{events:any[], last:boolean}} data */
    apply_historic_events(data) {
        this.is_last_page = !!data.last;
        var events = Object.values(data.events);
        for (var e of events) this.apply_event(e, true);
        this.initialized = true;
    }

    update_entries() {
        for (var e of Object.values(this.entries)) e.update();
    }

    apply_event(event, historic = false) {
        if (event.type == "update") {
            if (this.entries[event.data.id]) {
                this.entries[event.data.id].update(event.data);
            } else {
                if (!this.pending_updates[event.data.id]) this.pending_updates[event.data.id] = [];
                this.pending_updates[event.data.id].push(event);
            }
        } else {
            let entry;
            if (event.type == "meta") {
                var msg = event.data.message;
                if (event.data.init) msg = `Chat initialized on ${new Date(event.ts).toLocaleString("en-GB")}.`
                else if (event.data.restart) msg = `Chat restarted on ${new Date(event.ts).toLocaleString("en-GB")}.`
                else if (event.data.gap !== undefined) {
                    let date1 = new Date(event.data.gap[1]);
                    let date2 = new Date(event.data.gap[2]);
                    if (date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth() || date1.getDate() !== date2.getDate()) {
                        msg = format_date_human(date1);
                    } else {
                        msg = utils.time_delta_readable(-event.data.gap[0]).replace(/\sago/, "");
                    }
                }
                if (msg) {
                    entry = new ChatMetaEntry(this, event, msg);
                }
            } else if (event.type == "new") {
                entry = new ChatEntry(this, event);
                if (this.pending_updates[event.id]) {
                    this.pending_updates[event.id].sort((a, b) => a.id - b.id);
                    for (var d of this.pending_updates[event.id]) {
                        entry.update(d.data);
                    }
                    delete this.pending_updates[event.id];
                }
                if (!historic) {
                    var volume = app.settings.get("audio-volume");
                    var play_sound = app.settings.get("message-audio");
                    if (play_sound) {
                        if (entry.$.text) app.play_sound("message", volume);
                    }
                }
            }

            if (entry) {
                /** @type {HTMLElement} */
                var adjacent;
                if (historic) {
                    adjacent = this.entry_container_el.firstElementChild;
                    this.entry_container_el.prepend(entry.elem);
                } else {
                    adjacent = this.entry_container_el.lastElementChild;
                    this.entry_container_el.append(entry.elem);
                }
                var adjacent_entry_id = adjacent?.dataset.id || "";
                var adjacent_entry = this.entries[adjacent_entry_id];

                if (event.data.gap === undefined && adjacent_entry) {
                    var diff = Math.abs(adjacent_entry.ts - entry.ts);
                    if (diff > CHAT_GAP) {
                        var meta_entry = this.apply_event({
                            "id": --fake_chat_id,
                            "ts": entry.ts,
                            "type": "meta",
                            "data": { "gap": [diff, adjacent_entry.ts, entry.ts] }
                        })
                        if (historic) entry.elem.after(meta_entry.elem);
                        else entry.elem.before(meta_entry.elem);
                    }
                }

                entry.elem.classList.toggle("even", adjacent ? !adjacent.classList.contains("even") : false);

                this.entry_container_el.style.setProperty("--estimated-height", `${this.entry_container_el.childElementCount * 50}px`);

                if (!historic) {
                    if (!this.efficient) $(entry.content_elem).hide().fadeIn(300);
                    // this.update_scroll(0);
                }
                return entry;
            } else {
                console.debug("Ignoring chat event", event);
            }
        }

        var now = Date.now();
        while (this.entry_container_el.childElementCount > this.MAX_CHAT_ENTRIES) {
            var entry = this.first_entry;
            if (!entry) break;
            if (entry.ts_client + CHAT_CLIENT_EXPIRE_TIME >= now) break;
            entry.destroy();
        }

        this.update_next_frame();
    }

    async try_load_previous_page() {
        if (!this.initialized) return;
        if (this.is_last_page) return;
        await Promise.resolve(this.load_promise).catch(utils.noop);
        this.load_promise = (async () => {
            var data = await app.request("get_chat_events", [this.first_entry_id - 1, CHAT_BLOCK_AMOUNT]);
            if (data) {
                var sb = this.scroll_bottom;
                this.apply_historic_events(data);
                this.update_scroll(sb);
            }
            await utils.timeout(1000);
        })();
    }
}

class ChatEntryBase {
    ts = 0;

    /** @type {ChatEntryBase} */
    get prev() {
        var el = this.elem.previousElementSibling;
        while (el) {
            if (el.classList.contains("chat-entry")) return this.chat.entries[+el.getAttribute("data-id")];
            el = el.previousElementSibling;
        }
    }
    /** @type {ChatEntryBase} */
    get next() {
        var el = this.elem.nextElementSibling;
        while (el) {
            if (el.classList.contains("chat-entry")) return this.chat.entries[+el.getAttribute("data-id")];
            el = el.nextElementSibling;
        }
    }
    /** @type {ChatEntryBase[]} */
    children = [];

    /** @param {Chat} chat @param {any} event */
    constructor(chat, event, clazz) {
        this.chat = chat;
        this.event = event;

        this.id = event.id;
        this.ts = event.ts;
        this.ts_client = Date.now();

        if (this.chat.entries[this.id]) {
            this.chat.entries[this.id].children.push(this);
        } else {
            this.chat.entries[this.id] = this;
        }

        this.$ = {};
        this.elem = $(`<div>`)[0];
        this.elem.classList.add(clazz);
        this.elem.setAttribute("data-id", this.id);
        this.elem.setAttribute("data-ts", this.ts);

        this.debounced_update = dom.debounce_next_frame(() => {
            this._update();
            app.chat.update_scroll();
        });
        this.update(event.data);
    }

    update(data) {
        if (data) utils.deep_merge(this.$, data);
        this.debounced_update();
    }

    destroy() {
        delete this.chat.entries[this.id];
        for (var e of this.children) e.destroy();
        this.elem.remove();
    }

    _update() {
        throw new Error("Not implemented");
    }
}

class ChatMetaEntry extends ChatEntryBase {
    constructor(chat, event, msg) {
        super(chat, event, "chat-meta-entry");
        if (event.data.gap !== undefined) this.elem.classList.add("gap");
        if (event.data.restart !== undefined) this.elem.classList.add("restart");
        this.elem.innerHTML = `<div class="content">${msg}</div>`;
    }
    _update() { return; }
}

class ChatEntry extends ChatEntryBase {
    constructor(chat, event) {
        super(chat, event, "chat-entry");

        this.elem.innerHTML = `<div class="content"></div><button class="dropdown" aria-expanded="false"><i class="fas fa-ellipsis-v"></i></button>`;
        this.content_elem = this.elem.querySelector(".content");
        let dropdown_button = this.elem.querySelector("button.dropdown");
        var menu = new dom.DropdownMenu({
            target: dropdown_button,
            // parent: app.chat.elem,
            trigger: "click",
            items: () => {
                var items = [
                    {
                        icon: `<i class="fas fa-info-circle"></i>`,
                        label: "Information",
                        hidden: this.$.hidden && !app.$._client.user.is_admin,
                        click: () => {
                            app.chat.overlay_container.toggle("comment-info", () => new CommentInfoInterface(this.id))
                        }
                    },
                    {
                        icon: `<i class="fas fa-flag"></i>`,
                        label: "Report",
                        hidden: this.$.hidden,
                        disabled: this.ip === app.$._client.ip,
                        click: () => {
                            app.chat.overlay_container.toggle("comment-report", () => new CommentReportInterface(this.id));
                        }
                    }
                ];
                if (app.$._client.user.is_admin) {
                    items.push({
                        icon: this.$.hidden ? `<i class="fas fa-eye-slash"></i>` : `<i class="fas fa-eye"></i>`,
                        label: this.$.hidden ? "Unhide" : "Hide",
                        click: () => {
                            var hidden = !this.$.hidden;
                            this.update({ hidden });
                            app.request("update_comment", [this.id, { hidden }]);
                        }
                    });
                }
                return items;
            }
        });
        menu.on("hide", () => {
            app.chat.menus.delete(menu);
            app.chat.emit("tippy");
        });
        menu.on("show", () => {
            app.chat.menus.add(menu);
            app.chat.emit("tippy");
        });
    }

    _update() {
        var is_blocked = app.is_blocked(this.$);
        this.elem.toggleAttribute("data-hidden", !!this.$.hidden);
        // this.elem.toggleAttribute("data-deleted", !!this.$.deleted);
        this.elem.toggleAttribute("data-blocked", is_blocked);
        this.elem.toggleAttribute("data-gift", !!this.$.gift);

        let name = this.$.author;
        let origin_livestream = app.$.livestreams[this.$.livestream_id];

        if (!app.display_name_map[this.$.ip]) {
            app.display_name_map[this.$.ip] = new Set();
        }
        app.display_name_map[this.$.ip].add(name);

        if (this.$.hidden) {
            this.content_elem.innerHTML = `This comment is hidden`;
        } else {
            var prefix = `<span class="status"></span><span class="ts"></span><span class="author username"><span class="author-avatar"><img loading="lazy"></span><span class="author-text"></span></span>`;
            if (this.$.text !== undefined) {
                this.content_elem.innerHTML = prefix + `<span class="space">:&nbsp;</span><span class="comment"></span>`;
            } else if (this.$.gift !== undefined) {
                if (this.$.gift == "goal") {
                    this.content_elem.innerHTML = prefix + `scored a goal!`;
                } else if (this.$.gift == "fireworks") {
                    this.content_elem.innerHTML = prefix + `set off fireworks!`;
                } else if (this.$.gift == "psycho") {
                    this.content_elem.innerHTML = prefix + `is a <span style="color:red;font-weight:bold">psycho!</span>`;
                } else if (this.$.gift == "shark") {
                    this.content_elem.innerHTML = prefix + `is gonna need a bigger boat...`;
                } else {
                    this.content_elem.innerHTML = prefix + `sent ${this.$.gift}!`;
                }
            }
        }

        let author_elem = this.content_elem.querySelector(".author");
        let author_text_elem = this.content_elem.querySelector(".author-text");
        let avatar_elem = this.content_elem.querySelector(".author-avatar");
        var status_elem = this.content_elem.querySelector(".status");
        let comment_elem = this.content_elem.querySelector(".comment");
        let ts_elem = this.content_elem.querySelector(".ts");

        if (ts_elem) {
            var ts_mode = app.settings.get("comment-timestamps-mode");
            if (ts_mode == "hh:mm") {
                ts_elem.innerHTML = new Date(this.ts).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
            } else if (ts_mode == "hh:mm:ss") {
                ts_elem.innerHTML = new Date(this.ts).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            }
            ts_elem.style.display = ts_mode ? "" : "none";
        }

        if (avatar_elem) {
            avatar_elem.style.display = this.$.avatar ? "" : "none";
            if (this.$.avatar) {
                avatar_elem.children[0].src = this.$.avatar;
            }
        }

        if (author_elem) {
            author_text_elem.innerHTML = name;
            author_elem.classList.toggle("logged-in", !!this.$.username);
        }

        if (this.$.text !== undefined && comment_elem) {
            var text = String(this.$.text).trim();
            text = text.replace(/[\n\r]+/g, " ");
            text = text.replace(/\u200D+/g, "");
            text = text.replace(/(<([^>]+)>)/gi, "").trim(); // strip html
            comment_elem.innerHTML = text.replace(urls_regex, (url) => {
                let url_ob = utils.try_catch(() => new URL(url));
                if (url_ob) {
                    let is_live_link = url_ob.origin == location.origin && url_ob.pathname == location.pathname;
                    if (is_live_link) {
                        if (url_ob.hash) url = url_ob.hash;
                    }
                    let target = "_blank";
                    let text = "[Link]";
                    if (is_live_link) {
                        target = "_self";
                        text = `[Layout]`;
                    }
                    url = `<a href="${encodeURI(decodeURI(url))}" target="${target}">${text}</a>`;
                }
                return url;
            });
        }

        var title_lines = [];
        if (origin_livestream) {
            // -- 
        } else if (this.$.username) {
            title_lines.push(`Logged in as ${this.$.username}`);
        } else {
            title_lines.push(`Not logged in`);
        }
        if (this.$.ip && app.$._client.user.is_admin) title_lines.push(`IP: ${this.$.ip}`);
        else if (this.$.ip_hash) title_lines.push(`IP Hash: ${this.$.ip_hash}`);
        // else if (this.$.fc2) title_lines.push(`FC2 User ID: ${this.$.fc2.encrypted_user_id}`);

        var origin_url = (origin_livestream) ? origin_livestream.url || "External" : window.location.host;
        var now = new Date();
        var ts = new Date(this.ts);
        var ts_str;
        if (ts.toDateString() !== now.toDateString()) {
            ts_str = `${ts.toLocaleDateString("en-GB")} ${ts.toLocaleTimeString("en-US")}`;
        } else {
            ts_str = ts.toLocaleTimeString("en-US");
        }
        title_lines.push(`Time sent: ${ts_str}`);

        var lines = [`Sent from ${origin_url}`];
        if (this.$.status) {
            for (var [ls_id, s] of Object.entries(this.$.status)) {
                var status_text = "Sending";
                if (s == 0) status_text = "Failed to send"
                else if (s == 1) status_text = "Sent"
                var ls = app.$.livestreams[ls_id];
                lines.push(`${status_text} to ${ls && ls.url ? ls.url : ls_id}`);
            }
            this.elem.dataset.status = Math.min(...Object.values(this.$.status));
        }
        if (author_elem) {
            author_elem.title = title_lines.join("\n");
        }
        if (status_elem) {
            status_elem.title = lines.join("\n");
        }
        if (origin_livestream) this.elem.dataset.external = 1;
    }
}

/** @param {LiveStream$} ls */
var is_active = (ls) => (ls.is_live || ls.is_vod) && (!ls.is_expired || ls._go_live);
/** @type {Record<PropertyKey,LiveStreamGroup$>} */
const LIVESTREAM_GROUPS = {
    "online": new LiveStreamGroup$("online", "Live", (ls) => is_active(ls)),
    "offline": new LiveStreamGroup$("offline", "Expired", (ls) => !is_active(ls)),
};

class LiveApp extends utils.EventEmitter {
    get is_fullscreen() { return document.fullscreenElement === this.elem; }
    get root_scroll_el() { return document.fullscreenElement || document.documentElement; }
    #updating = false;
    /** @type {AudioContext} */
    #audio_ctx;
    /** @type {Promise<AudioContext>} */
    #audio_ctx_promise;
    /** @type {Record<string,AudioBuffer>} */
    #audio_buffers = {};
    #sounds = {
        // "kiss": cabtv.template_url+"/audio/kiss.wav",
        // "fart": cabtv.template_url+"/audio/fart.wav",
        "message": cabtv.template_url + "/audio/message.mp3",
        "gift": cabtv.template_url + "/audio/gift.mp3",
    };
    #last_go_lives_hash;
    #go_lives_changes = 0;
    blocking_updates = new utils.PromiseSet();
    current_livestream_ids = [];
    $ = new Remote$();

    get current_livestreams() {
        return this.current_livestream_ids.map(id => this.$.livestreams[id]).filter(ls => ls);
    }
    get hash_ids() { return window.location.hash.slice(1).split(",").filter(h => h); }

    get auto_id() {
        var go_live = this.$._active_go_live;
        if (go_live && go_live._livestreams.length) {
            return "go-live-" + go_live.id;
        }
        var live_livestreams = this.$._livestreams_ordered.filter(ls => !ls.is_expired);
        var default_livestream_id = live_livestreams[0] ? live_livestreams[0].id : null;
        return default_livestream_id;
    }
    get is_auto() { return utils.array_equals(this.hash_ids, [AUTO]); }

    constructor() {

        super();

        app = this;
        window.app = this;

        this.messenger = new dom.WindowCommunicator();

        var { main_url, cabtv_url, key } = cabtv.livestreamer_config;
        var ws_url = new URL(cabtv_url.replace(/^http(s)?:\/\//, "ws$1://"));
        if (key) ws_url.searchParams.append("cabtv_auth", key);

        this.ws = new dom.ReconnectingWebSocket();
        this.ws.on("open", () => {
            this.$ = new Remote$();
            this.chat.reset();
        });

        this.ws.on("data", async (data) => {
            if (data.event) {
                this.chat.ready.then(() => {
                    this.chat.apply_event(data.event);
                });
                if (data.event.type == "new" && data.event.data.gift) {
                    this.display_gift(data.event.data);
                }
            } else {
                utils.remote.apply$(this.$, data);
                this.update_next_frame();
            }
        });
        this.ws.on("close", async () => {
            this.update_next_frame();
        });

        this.display_name_map = {};

        this.show_sidebar = true;

        this.elem = document.querySelector("#live-wrapper");

        this.root = new ui.UI(document.body);

        this.disable_scroll_class = dom.create_disable_scrollbars_stylesheet_and_class();

        var chat_wrapper_el = document.querySelector(".chat-ui-wrapper");

        this.chat = new Chat(chat_wrapper_el);

        // this.chat_video_wrapper_el.addEventListener("transitionstart", );

        this.settings = new dom.LocalStorageBucket(`live-${major_version}`, {
            "chat-username": cabtv.user.data.user_nicename || "Anonymous",
            "chat-font-size": 14,
            "chat-font-style": "",
            "show-blocked-comments": false,
            "show-gifts": true,
            "message-audio": false,
            "audio-volume": 1,
            "show-tv-static-no-livestream": false,
            "comment-timestamps-mode": "hh:mm",
            "show-avatars": true,
            "autoplay": "focused",
            "darkmode": true,
            "video-below-chat": false,
        });

        this.settings.on("change", (e) => {
            if (e.name == "darkmode") this.toggle_darkmode(e.new_value);
        });

        this.settings.load();

        this.settings.on("change", (e) => {
            debounced_update_settings();
        });

        var debounced_update_settings = dom.debounce_next_frame(() => {
            Object.values(this.chat.entries).forEach(e => e.update());
            this.update();
        });

        document.addEventListener("click", (e) => {
            var anchor = e.target.closest("a");
            if (!anchor) return;
            var hash = dom.get_anchor_same_origin_hash(anchor);
            if (hash) {
                e.preventDefault();
                if (hash !== location.hash) {
                    location.hash = hash;
                }
            }
        });

        window.addEventListener("message", (e) => {
            if (e.data.type === 'video-status') {
                var { origin, ended } = e.data.data;
                var ls = this.current_livestreams.find(ls => ls._view.iframe_el.src == origin);
                if (ls) ls.user_ended = ended;
            }
        })

        window.addEventListener("hashchange", (e) => {
            this.set_livestreams(location.hash.slice(1).split(","), false);
            return false;
        });

        // var scrolling = false, scroll_timeout;
        // window.addEventListener("scroll", (e) => {
        //     scrolling = true;
        //     clearTimeout(scroll_timeout);
        //     scroll_timeout = setTimeout(()=>{
        //         scrolling = false;
        //     }, 200);
        // });

        // var debounce_keyboard_show = utils.debounce(()=>{
        //     console.log("debounce_keyboard_show");
        //     this.viewer.focus();
        // }, 100)

        // var max_height = 0;
        var is_mini = this.is_mini;
        var resize = () => {
            if (is_mini !== this.is_mini) {
                this.viewer.debounced_focus();
            }
            // let w = window.visualViewport?.width || window.innerWidth;
            // let h = window.visualViewport?.height || window.innerHeight;
            // max_height = Math.max(max_height, h);
            // console.log(max_height - h)
            // if (max_height - h > 100) {
            //     this.viewer.focus(false);
            // }
            // this.elem.style.setProperty("--vw", `${w}px`);
            // this.elem.style.setProperty("--vh", `${h}px`);
        };
        var debounced_resize = utils.debounce(() => resize(), 100);

        window.visualViewport?.addEventListener("resize", debounced_resize);
        window.addEventListener("resize", debounced_resize);
        // window.addEventListener("orientationchange", ()=>{
        //     max_height = 0
        // });

        document.addEventListener("fullscreenchange", () => {
            dom.toggle_class(this.elem, "fullscreen", this.is_fullscreen);
            this.update_next_frame();
        });
        
        // setTimeout(() => {
        //     resize();
        // }, 0);

        // window.addEventListener('orientationchange', (event) => {
        //     console.debug("orientationchange");
        // });

        var noSleep = new NoSleep();
        document.addEventListener('click', function enable_NoSleep() {
            document.removeEventListener('click', enable_NoSleep, false);
            noSleep.enable();
        }, false);

        document.addEventListener('click', () => {
            this.#setup_audio();
        });

        // ------------------------------------

        if (!IS_CHAT_MODE) {
            this.chat_and_video_wrapper_el = document.querySelector(".chat-and-livestream-container");
            this.chat_and_video_wrapper_el.addEventListener("click", () => {
                // if (app.chat.input.is_focussed) return;
                this.viewer.debounced_focus();
            });

            new ResizeObserver(() => {
                var sidebar_width = this.get_sidebar_width();
                this.sidebar_el.style.width = this.show_sidebar ? `${sidebar_width}px` : 0;
                this.chat.elem.style.width = `${sidebar_width}px`;
            }).observe(this.chat_and_video_wrapper_el);

            this.sidebar_el = this.chat_and_video_wrapper_el.querySelector(".live-sidebar");
            this.side_handle_el = this.chat_and_video_wrapper_el.querySelector(".side-handle");
            this.side_handle_el.onclick = () => this.toggle_sidebar(!this.show_sidebar);

            this.viewer = new ViewerUI(this.chat_and_video_wrapper_el.querySelector(".content-wrapper"));
            this.channel_manager = new ChannelManagerUI(document.querySelector(".channels-wrapper"));

            this.channel_manager.set_group(LIVESTREAM_GROUPS.online.id);
        }

        setInterval(() => this.tick(), 1000);

        this.ws.connect(ws_url.toString());

        this.update();

        cabtv.init_bs_tooltips();
        cabtv.nav.disable_sticky();
    }

    // such a total mess.
    set_livestreams(ids, update_hash = false) {
        if (IS_CHAT_MODE) return;
        if (!Array.isArray(ids)) ids = [ids];
        if (!this.ws.is_open) return;

        var auto_id = this.auto_id;
        var current_livestream_ids = [...this.current_livestream_ids];
        var current_livestreams = this.current_livestreams;
        ids = ids.filter(id => id);
        var old_hash = window.location.hash.slice(1);

        if (ids.length == 0 || (this.$._livestream_id_updates == 0 && ids.length == 1 && ids[0] == auto_id)) { // if no specified ids or if we're on the first livestream_id_update and the only id matches the auto_id
            ids = [AUTO];
            update_hash = true;
        }

        var is_none = ids.length == 1 && ids[0] === NONE;
        var is_auto = ids.length == 1 && ids[0] === AUTO;
        var is_go_live = ids.length == 1 && ids[0].match(/^go-live-(\d+)$/);

        /** @param {string} id */
        var process = (id) => {
            if (!id) return;
            var go_live_id = id.match(/^go-live-(\d+)$/)?.[1];
            if (go_live_id) {
                let go_live = this.$.go_lives[go_live_id];
                if (go_live) {
                    if (go_live.livestream_ids.length) {
                        if (go_live.show_multiple) new_livestream_ids.push(...go_live.livestream_ids);
                        else new_livestream_ids.push(...go_live.livestream_ids.slice(0, 1));
                    }
                } else if (id !== auto_id) {
                    update_hash = true;
                    return process(AUTO);
                }
            }
            if (id === NONE) return NONE;
            if (id === AUTO) process(auto_id);
            else if (this.$.livestreams[id]) new_livestream_ids.push(id);
            else return;
            return id;
        }

        var new_livestream_ids = [];
        ids = ids.map(process).filter(id => id);
        new_livestream_ids = [...new Set(new_livestream_ids)];
        var new_livestreams = new_livestream_ids.map(id => this.$.livestreams[id]);
        if (!new_livestream_ids.length && !is_none) {
            ids = [process(AUTO)];
            update_hash = true;
        }

        if (is_auto && current_livestreams.some(ls => ls.host === CABTV_CO_UK) && new_livestreams.filter(ls => ls.host === CABTV_CO_UK && ls.is_live).length == 0) {
            // if we are already watching a cabtv, auto must include 1 live cabtv, otherwise we ignore auto completely.
            return;
        }
        /* if (is_auto && this.current_livestreams.every(ls=>!ls.user_ended)) {
            return;
        } */

        let focus = false;
        let new_hash = ids.join(",");
        if (old_hash !== new_hash) {
            if (update_hash) {
                window.location.hash = new_hash;
                focus = true;
            }
        }

        var old_id_hash = JSON.stringify(this.current_livestream_ids);
        var new_id_hash = JSON.stringify(new_livestream_ids);
        this.current_livestream_ids = new_livestream_ids;
        if (new_id_hash !== old_id_hash) {
            focus = true;
            this.request("livestream_connect", new_livestream_ids);
            let livestreams = this.current_livestreams;
            this.elem.dataset.videos = livestreams.length;
            if (livestreams.length && !current_livestream_ids.includes(new_livestream_ids[0])) {
                livestreams[0]._thumbnail.focus();
            }
            this.root.update();
        }

        if (focus) {
            this.viewer.debounced_focus();
        }

        this.$._livestream_id_updates++;
    }

    async #fetch_audio(url) {
        const response = await fetch(url);
        return await this.#audio_ctx.decodeAudioData(await response.arrayBuffer());
    }

    async #setup_audio() {
        if (!this.#audio_ctx_promise) {
            this.#audio_ctx_promise = (async () => {
                if (this.#audio_ctx) {
                    return this.#audio_ctx.resume();
                }
                this.#audio_ctx = new AudioContext();
                await Promise.all(Object.entries(this.#sounds).map(async ([k, v]) => {
                    this.#audio_buffers[k] = await this.#fetch_audio(v);
                }));
            })();
        }
        return this.#audio_ctx_promise;
    }

    async play_sound(name_or_url, volume = 1) {

        if (!document.hasFocus()) return;
        
        if (!this.#audio_buffers[name_or_url]) {
            this.#audio_buffers[name_or_url] = await this.#fetch_audio(name_or_url);
        }
        var source = this.#audio_ctx.createBufferSource();
        source.buffer = this.#audio_buffers[name_or_url];
        if (volume !== 1) {
            var gainNode = this.#audio_ctx.createGain();
            gainNode.gain.value = volume * app.settings.get("audio-volume");
            source.connect(gainNode);
            gainNode.connect(this.#audio_ctx.destination);
        } else {
            source.connect(this.#audio_ctx.destination);
        }
        source.start(0);
    }

    get total_users() {
        var total_users = [...utils.group_by(Object.values(this.$.clients), c => c.ip_hash)].length;
        // total_users += utils.sum(Object.values(this.$.livestreams).filter(ls=>!ls.is_expired).map(ls=>ls.user_count));
        return total_users;
    }
    get is_mobile() { return new URL(location.href).searchParams.get("mobile") ?? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); }
    get is_mini() { return window.innerWidth <= 640 || window.innerHeight <= 440; }
    get is_touch() { return new URL(location.href).searchParams.get("touch") ?? dom.has_touch_screen(); }

    async toggle_sidebar(value) {
        value = (value === undefined) ? !this.show_sidebar : !!value;
        if (this.show_sidebar === value) return;
        this.show_sidebar = value;
        dom.toggle_class(this.elem, "show-sidebar", this.show_sidebar);
        this.chat.update_scroll(0);
        $(this.sidebar_el).animate({
            width: this.show_sidebar ? this.get_sidebar_width() : 0
        }, {
            duration: 200,
        });
    }

    async toggle_chat_popout() {
        if (this.external_chat_window) {
            this.external_chat_window.close();
            this.external_chat_window = null;
            this.toggle_sidebar(true);
        } else {
            var url = new URL(location.href);
            url.hash = "";
            url.searchParams.set("chat", "1");
            this.external_chat_window = window.open(url.toString(), "_blank", "width=400,height=700,scrollbars=1,resizable=1,fullscreen=yes");
            if (!this.external_chat_window) this.external_chat_window = window.open(url.toString(), "_blank");
            if (!this.external_chat_window) return;
            await new Promise(r => this.external_chat_window.window.addEventListener("load", r));
            this.external_chat_window.window.addEventListener("unload", () => {
                this.toggle_chat_popout();
            });
            this.toggle_sidebar(false);
        }
    }

    tick() {
        this.update();
        for (var ls of this.current_livestreams) {
            ls._view.tick();
        }
    }

    async update() {
        if (this.#updating) return;
        this.#updating = true;
        await this.blocking_updates.ready;
        this.#update();
        this.#updating = false;
    }

    update_next_frame = dom.debounce_next_frame(this.update.bind(this));

    async #update() {
        var video_below_chat = this.settings.get("video-below-chat");
        this.elem.classList.toggle("video-below-chat", video_below_chat);
        this.elem.classList.toggle("video-below-chat", video_below_chat);
        dom.toggle_class(this.elem, "is-touch", this.is_touch);

        if (!this.$.chat_initialized && this.ws.is_open) {
            this.chat_connect();
            this.$.chat_initialized = true;
        }

        if (this.$.go_lives_hash !== this.#last_go_lives_hash) {
            this.#last_go_lives_hash = this.$.go_lives_hash;
            if (this.#go_lives_changes != 0) {
                cabtv.fetch_announcements();
            }
            this.#go_lives_changes++;
        }

        this.set_livestreams(this.hash_ids, false);

        this.root.update();
    }

    async chat_connect(id) {
        var last_id = app.settings.get("last-chat-id");
        id = id ?? last_id;
        if (id && app.$._client.chat_id === id) return;
        var res = await this.request("chat_connect", [id]);
        if (!res) return;
        var { id, events } = res;
        app.settings.set("last-chat-id", id);
        if (id !== last_id) {
            this.chat.reset();
        }
        this.chat.apply_historic_events(events);
        this.chat.update_scroll(0);
    }

    async display_gift(gift_data) {
        if (!this.settings.get("show-gifts")) return;
        var current_livestreams = this.current_livestreams;
        var parent;
        if (IS_CHAT_MODE) {
            parent = this.chat.elem;
        } else if (current_livestreams.length === 1) {
            parent = current_livestreams[0]._view.container_el;
        } else {
            parent = this.viewer.elem;
        }
        var {gift} = gift_data;
        let container_el = $(`<div>`)[0];
        container_el.style.position = "absolute";
        container_el.style.inset = "0";
        container_el.style.overflow = "hidden";
        container_el.style.pointerEvents = "none";
        parent.append(container_el);
        var g = gifts.find(g=>g.type == gift);
        await g.show(container_el, gift_data);
    }

    get_sidebar_width() {
        return utils.clamp(window.innerWidth * 0.3, 240, 450);
    }

    async send_chat(c) {
        var author = this.settings.get("chat-username") || this.$._client.username || "Anonymous";
        return this.request("send_chat", [{ author, ...c }]);
    }

    async delete_livestream(id) {
        this.request("delete_livestream", [id]);
    }

    async request(method, args) {
        var request = { method, arguments: args };
        return this.ws.request(request);
    }

    is_blocked(o) {
        if (o.username && o.username in this.$.chat_blocklist) return true;
        if (o.ip && o.ip in this.$.chat_blocklist) return true;
        if (o.ip_hash && o.ip_hash in this.$.chat_blocklist) return true;
        // if (o.fc2 && o.fc2.encrypted_user_id in this.$.chat_blocklist) return true;
        return false;
    }

    async chat_blocklist_toggle(key) {
        await this.request("chat_blocklist_toggle", [key]);
    }

    toggle_darkmode(value) {
        if (value === undefined) value = !this.darkmode;
        if (this.darkmode == value) return;
        this.darkmode = value;
        if (this.darkmode == "auto") {
            Cookies.remove("live-darkmode");
            this.elem.removeAttribute("data-darkmode");
        } else {
            Cookies.set("live-darkmode", this.darkmode ? "1" : "0");
            this.elem.dataset.darkmode = this.darkmode;
        }
    }
}

function add_keyframes(name, keyframes) {
    if (document.head.querySelector(`#keyframes-${name}`)) return;
    document.head.appendChild($(`<style id="keyframes-${name}">@keyframes ${name} {${keyframes}}</style>`)[0]);
}
function scale_span(text, size=1) {
    return `<span style="display:inline-block; text-shadow: 0 0 10px rgba(0,0,0,0.5); transform: scale(${size});">${text}</span>`;
}

/** @type {LiveApp} */
export let app;
new LiveApp();